import React from "react";
import contextProvider from "../../contextProvider";
import CreatableSelect from "react-select/creatable";
import { Row, Col, ButtonGroup, Label, FormText, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";
import {
  _LoadingWrapper,
  LoadingSpin,
} from "../../_L0_components/Widgets/_LoadingKit";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOModal from "../../_L1_components/Elements/ReactOModal";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactODropdown from "../../_L1_components/Elements/ReactODropdown";
import ReactOCollapse from "../../_L1_components/Elements/ReactOCollapse";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";
import Section from "../../_L1_components/Layout/Section";
import Panel from "../../_L1_components/Layout/Panel";
import ReactOTable from "../../_L1_components/Elements/ReactOTable";
import {
  compressGzip,
  encodeBase64,
  base64ToUint8Array,
  decompressGzipFromBase64,
} from "../../lib/utils";

const context_exposed_methods = [];

class ProbeConfig extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      probe_confs: {},
      probe_cst_sync_status: {},
      probe_network_scan: {},
      probe_tests: {},
      modalDescription: "-",
      forcing: undefined,
      toRedirect: false,
      loading_cve: false,
      disableTags: true,
      msgCopy: "Copy link",
      editingModalSize: "lg",
      tagsList: [],
      _cloneMode: false,
    };
    super(props, initState);
    this.apiStore = null;
    this._cloneOriginalName = "";
    this._cloneNameRef = React.createRef();
    this.customStyles = {
      control: (provided, state) => ({
        ...provided,
        color: "#495057",
        backgroundColor: "#fff",
        borderColor: state.isFocused ? "#8bb8df" : provided.borderColor,
        boxShadow: state.isFocused
          ? "0 0 0 0.2rem rgba(51, 122, 183, 0.25)"
          : provided.boxShadow,
        "&:hover": {
          borderColor: state.isFocused ? "#8bb8df" : provided.borderColor,
        },
      }),
      multiValue: (provided) => ({
        ...provided,
        backgroundColor: "white",
        border: "1px solid #495057",
        borderRadius: "10rem",
        // paddingRight: "0.4em",
        // paddingLeft: "0.4em",
        // paddingTop: "0.2em",
        // paddingBottom: "0.2em",
      }),
      multiValueLabel: (provided) => ({
        ...provided,
        fontSize: "14px",
        color: "#495057",
      }),
      multiValueRemove: (provided) => ({
        ...provided,
        cursor: "pointer",
        ":hover": {
          backgroundColor: "none",
          // color: "white",
        },
      }),
    };
  }

  /////////////////////////
  //	Lifecycle methods
  //

  defineCallSet() {
    this.callsSet = this.apiStore.newCallsSet({
      state_setter: this._getStateSetter(),
      calls_set: {
        probe_confs: {
          api_id: "get_probe_confs",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
          pre_datastore: (data) => {
            let _TMP = { active: [], archived: [] };
            data.forEach((_CURR_conf, _CURR_idx) => {
              (_CURR_conf.archived ? _TMP.archived : _TMP.active).push(
                _CURR_conf,
              );
            });
            return _TMP;
          },
        },
        probe_cst_sync_status: {
          api_id: "probe_cst_sync_status",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        measure_certificates: {
          api_id: "get_measure_certificates",
          loading_key: "measure_certificates_loading",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        get_notifications: {
          api_id: "get_notifications",
          // loading_key: "measure_certificates_loading",
          // static_data: {
          //   probeuid: this.props.match.params.probeuid,
          // },
        },
        parse_measure_certificate: {
          api_id: "parse_measure_certificate",
          loading_key: "parse_measure_certificate_loading",
        },
        parse_measure_pkey: {
          api_id: "parse_measure_pkey",
          loading_key: "parse_measure_pkey_loading",
        },
        probe_network_scan: {
          api_id: "get_probe_network_scan",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        probe_tests: {
          api_id: "get_probe_tests",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        set_probe_confs_with_filter: {
          api_id: "set_probe_confs_with_filter",
          loading_key: "loading_action",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        create_probe_conf: {
          api_id: "create_probe_conf",
          loading_key: "loading_action",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        pause_probe_conf: {
          api_id: "pause_probe_conf",
          loading_key: "loading_action",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        resume_probe_conf: {
          api_id: "resume_probe_conf",
          loading_key: "loading_action",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        archive_probe_conf: {
          api_id: "archive_probe_conf",
          loading_key: "loading_action",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        delete_probe_conf: {
          api_id: "delete_probe_conf",
          loading_key: "loading_action",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        csv_script: {
          api_id: "csv_script",
          // loading_key: "loading_action",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        probe_capabilities: {
          api_id: "probe_capabilities",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        settings_notifications: {
          api_id: "get_settings_notifications",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
      },
    });

    this.callsSet.call("probe_confs", {
      on_success: () => {
        this.setState({ forcing: false });

        if (this.props.match.params.initselection) {
          this._DATA_READY = true;
          this.openInitialSelection();
          // if (this._MODAL_READY) {
          //   this._DATA_READY = false;
          //   this._MODAL_READY = false;

          //   // this.openInitialSelection();
          // }
        }
      },
    });

    this.callsSet.call([
      "probe_network_scan",
      "probe_capabilities",
      "settings_notifications",
      ...(this.getAppContext().isCloud() ? ["probe_cst_sync_status"] : []),
    ]);
    if (this.getAppContext().isCloud()) {
      this.callsSet.call("get_notifications", {
        on_success: (_, response_data) => {
          this.setState({ notifications: response_data[0].data });
        },
      });
    }

    this.callsSet.call("probe_tests", {
      on_success: (_, response_data) => {
        // console.log("response_data[0].data", response_data[0].data);
        let clone = { ...response_data[0].data };
        let c_tests = this.filterCveTest(response_data[0].data.c_tests);
        let s_tests = this.filterCveTest(response_data[0].data.s_tests);
        clone = { ...clone, s_tests, c_tests };
        this.setState(
          {
            probe_tests: clone,
            ethlabels: response_data[0].data.ethlabels || ["LOC1"],
          },
          () => {
            if (
              response_data[0].data.ethlabels &&
              response_data[0].data.ethlabels.length > 0
            ) {
              this.parseTestsInfo(clone, true);
            } else {
              clone.ethlabels && delete clone.ethlabels;
              this.parseTestsInfo(clone, false);
            }
          },
        );
      },
    });
  }

  getAuthOptions(form_data) {
    let options = [];
    if (form_data.net_type != "ethernet") {
      options = [
        { name: "None", value: "" },
        { name: "WPA2 Personal", value: "PSK" },
        { name: "WPA3 Personal", value: "SAE" },
        { name: "WPA2 Enterprise", value: "PEAP" },
      ];
    }
    return options;
  }

  createTagsOptions() {
    const concat = [
      ...(this.state.probe_tests?.tags ?? []),
      ...(this.state.probe_confs?.active?.tags ?? []),
      ...(this.state.probe_confs?.archived?.tags ?? []),
    ];

    return [...new Set(concat)].map((t) => {
      return {
        value: t,
        label: t,
      };
    });
  }

  filterCveTest(arr) {
    const isCve = this.state?.probe_capabilities?.cve_test == "yes";
    if (isCve) {
      return arr.filter((t) => isCve && t.name != "CVE");
    } else {
      return arr;
    }
  }

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this.defineCallSet();
  }

  getNetType() {
    const cve =
      this.getAppContext().authHandler.getAccountData().CVEtest == "yes" ||
      false;
    let netType = [
      { name: "WiFi", value: "wifi", icon: "wifi" },
      {
        name: "Ethernet",
        value: "ethernet",
        icon: "ethernet",
      },
    ];
    if (this.state?.probe_capabilities?.cve_test == "yes" && cve) {
      netType.push({
        name: "CVE Test",
        value: "cve",
        icon: "monitor",
      });
    }
    return netType;
  }

  renderTags(tags) {
    if (tags && tags.length > 0) {
      const arrayOfTags = tags
        .split(", ")
        .sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" }));
      return arrayOfTags.map((t, id) => (
        <Badge
          style={{
            fontSize: "16px",
            fontWeight: "400",
          }}
          pill
          className="border bg-white border-gray700 text-gray700 mr-1"
          key={id}
        >
          {t}
        </Badge>
      ));
    }
  }

  parseTestsInfo(obj, ethlabels) {
    let label = null;
    if (ethlabels) {
      label = obj.ethlabels;
      label.unshift("None");
      delete obj.ethlabels;
    }
    let tests_info = {};
    let countOccurrences = { total: { ethernet: 0, wifi: 0 } }; // check for form init (ex no c_test / s_test for eth/wifi)
    Object.keys(obj).forEach((test) => {
      countOccurrences = {
        ...countOccurrences,
        [test]: { ethernet: 0, wifi: 0 },
      };
      obj[test].forEach((item) => {
        if (item.RJ45 && item.RJ45 == "yes") {
          countOccurrences[test].ethernet = countOccurrences[test].ethernet + 1;
          countOccurrences.total.ethernet = countOccurrences.total.ethernet + 1;
        } else {
          countOccurrences[test].wifi = countOccurrences[test].wifi + 1;
          countOccurrences.total.wifi = countOccurrences.total.wifi + 1;
        }

        tests_info = {
          ...tests_info,
          [item.name]: {
            desc: item.desc,
            extraParameters: item.extraParameters ? item.extraParameters : null,
            timeout: item.timeout ? item.timeout : null,
            label: item.RJ45 && item.RJ45 == "yes" ? label : null,
            doc: item.doc ? item.doc : null,
            excludedHW: item?.excludedHW || null,
          },
        };
      });
    });
    tests_info.countOccurrences = countOccurrences;
    // console.log("countOccurrences", tests_info);
    this.setState(
      {
        tests_info: tests_info,
      },
      // () => {
      //   console.log("?");
      //   this.openInitialSelection();
      // }
    );
  }

  filterTests(tests, netType) {
    const filtered = tests?.filter((t) => {
      return (
        (netType == "ethernet" && t.RJ45 == "yes") ||
        (netType != "ethernet" && (!t.RJ45 || t.RJ45 == "no"))
      );
    });
    return filtered || [];
  }

  sortTests(tests) {
    const positioned = tests.map((t) => ({
      ...t,
      script_position: t.script_position ? parseInt(t.script_position) : 999,
    }));
    const sortedByName = positioned.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    const sortByPosition = sortedByName.sort(
      (a, b) => a.script_position - b.script_position,
    );
    return sortByPosition;
  }

  getArchivedAlert(date) {
    const now = this.getAppContext().momentjs().unix();
    const year = 86400 * 366;
    const isOld = now - date > year;
    if (isOld) {
      return true;
    } else {
      return false;
    }
  }

  getMeasureStatus(data) {
    if (data?.archived) return "archived";
    if (data.paused) return "paused";
    return "running";
  }

  openInitialSelection() {
    const initSelection = this.props.match.params.initselection;
    if (initSelection) {
      this._measure_editing_modal.open(
        this.state.probe_confs.active.find((_CURR_measure) => {
          return _CURR_measure.cssid == initSelection;
        }) ||
          this.state.probe_confs.archived.find((_CURR_measure) => {
            return _CURR_measure.cssid == initSelection;
          }),
      );
    }
  }

  saveProbeConfs(data, cb) {
    this.callsSet.call("set_probe_confs_with_filter", {
      data_input: { measureid: data.cssid, value: data },
      on_success: (response_status, response_data) => {
        this.callsSet.call([
          "probe_confs",
          ...(this.getAppContext().isCloud() ? ["probe_cst_sync_status"] : []),
        ]);
        if (cb) cb(response_status, response_data[0]);
      },
      on_error: (response_error, response_data) => {
        if (cb) cb(response_error, response_data[0]);
      },
    });
  }

  createProbeConf(data, cb) {
    // console.log(data);
    //		console.log("DEBUG :: ProbeConfig _ createProbeConf");
    this.callsSet.call("create_probe_conf", {
      data_input: { value: data },
      on_success: (response_status, response_data) => {
        this.callsSet.call([
          "probe_confs",
          ...(this.getAppContext().isCloud() ? ["probe_cst_sync_status"] : []),
        ]);
        if (cb) cb(response_status, response_data[0]);
      },
      on_error: (response_error, response_data) => {
        if (cb) cb(response_error, response_data[0]);
      },
    });
  }

  pauseProbeConf(data, cb) {
    //		console.log("DEBUG :: ProbeConfig _ pauseProbeConf");
    this._prompt_modal.open({
      action_type: "pause",
      measure_name: data.name,
      action: () => {
        this.callsSet.call("pause_probe_conf", {
          data_input: { measureid: data.cssid },
          on_success: (response_status, response_data) => {
            this.callsSet.call([
              "probe_confs",
              ...(this.getAppContext().isCloud()
                ? ["probe_cst_sync_status"]
                : []),
            ]);
            if (cb) cb(response_status, response_data);
          },
          // on_error: (response_error, response_data) => {
          //   if (cb) cb(response_error, response_data[0]);
          // },
        });
      },
    });
  }

  runProbeConf(data, cb) {
    //		console.log("DEBUG :: ProbeConfig _ runProbeConf");
    this._prompt_modal.open({
      action_type: "run",
      measure_name: data.name,
      action: () => {
        this.callsSet.call("resume_probe_conf", {
          data_input: { measureid: data.cssid },
          on_success: (response_status, response_data) => {
            this.callsSet.call([
              "probe_confs",
              ...(this.getAppContext().isCloud()
                ? ["probe_cst_sync_status"]
                : []),
            ]);
            if (cb) cb(response_status, response_data);
          },
          // on_error: (response_error, response_data) => {
          //   if (cb) cb(response_error, response_data[0]);
          // },
        });
      },
    });
  }

  resumeProbeConf(data, cb) {
    //		console.log("DEBUG :: ProbeConfig _ resumeProbeConf");

    const testList = Object.keys(this.state.tests_info) || [];
    const testAvailable = testList.includes(data.test);

    if (testAvailable) {
      this._prompt_modal.open({
        action_type: "resume",
        measure_name: data.name,
        test_name: data.test,
        action: () => {
          data.configured && delete data.configured;
          data?.archived && delete data.archived;
          data.paused && delete data.paused;

          const update = {
            ...data,
          };
          this.createProbeConf(update, cb);
        },
      });
    } else {
      this._prompt_modal.open({
        action_type: "test_not_found",
        measure_name: data.name,
        test_name: data.test,
        action: () => {},
      });
    }
  }

  archiveProbeConf(data, cb) {
    //		console.log("DEBUG :: ProbeConfig _ archiveProbeConf");
    this._prompt_modal.open({
      action_type: "archive",
      measure_name: data.name,
      action: () => {
        this.callsSet.call("archive_probe_conf", {
          data_input: { measureid: data.cssid },
          on_success: (response_status, response_data) => {
            this.callsSet.call([
              "probe_confs",
              ...(this.getAppContext().isCloud()
                ? ["probe_cst_sync_status"]
                : []),
            ]);
            if (cb) cb(response_status, response_data);
          },
          // on_error: (response_error, response_data) => {
          //   if (cb) cb(response_error, response_data[0]);
          // },
        });
      },
    });
  }

  deleteProbeConf(data, cb) {
    //		console.log("DEBUG :: ProbeConfig _ deleteProbeConf");
    const status = this.getMeasureStatus(data);
    this._prompt_modal.open({
      action_type: "delete",
      measure_name: data.name,
      action: () => {
        this.callsSet.call("delete_probe_conf", {
          data_input: { measureid: data.cssid, status },
          on_success: (response_status, response_data) => {
            this.callsSet.call([
              "probe_confs",
              ...(this.getAppContext().isCloud()
                ? ["probe_cst_sync_status"]
                : []),
            ]);
            if (cb) cb(response_status, response_data);
          },
          // on_error: (response_error, response_data) => {
          //   if (cb) cb(response_error, response_data[0]);
          // },
        });
      },
    });
  }

  componentDidUpdate(prev_props) {
    if (
      prev_props.match.params.probeuid !== undefined &&
      this.props.match.params.probeuid != prev_props.match.params.probeuid
    ) {
      if (this._measure_editing_form) {
        // Reset Form
        this._measure_editing_form = undefined;
      }
      this.defineCallSet();
    }
  }

  onRender() {
    return (
      <Section designType="wide">
        <Section
          designType="wide"
          className="mb-4 border-bottom border-3 border-gray300"
        >
          <div className="d-flex px-4 pt-4 pb-3">
            <div className="flex-grow-1">
              <div className="d-flex align-items-baseline">
                <h2>Measures setup </h2>
                {/* <div
                  id="tp_copy_link"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => {
                    this.setState({ msgCopy: "Copy link" });
                  }}
                  onClick={() => {
                    this.getAppContext().copyURL();
                    this.setState({ msgCopy: "Copied" });
                  }}
                  onMouseLeave={() => {
                    setTimeout(() => {
                      this.setState({ msgCopy: "Copy link" });
                    }, 200);
                  }}
                  className="ml-3"
                >
                  <small className="icon-link" />
                </div>
                <ReactOTooltip
                  placement="right"
                  target="tp_copy_link"
                  text={this.state.msgCopy}
                /> */}
              </div>

              <small className="text-muted">
                Setup measures for currently selected probe
              </small>
            </div>
            {this.getAppContext().isCloud() ? (
              <small className="text-right text-muted align-self-end">
                <div>
                  {this.state.probe_cst_sync_status.probe_status ==
                    "not_deployed" &&
                  this.state.probe_cst_sync_status.sync_status == 1 ? (
                    <span className="text-muted">Probe not deployed</span>
                  ) : this.state.probe_cst_sync_status.probe_status ==
                      "maintenance" &&
                    this.state.probe_cst_sync_status.sync_status == 1 ? (
                    <span className="text-muted">Probe in maintenance</span>
                  ) : this.state.probe_cst_sync_status.probe_status ==
                      "deployed" &&
                    this.state.probe_cst_sync_status.sync_status == 0 ? (
                    <span className="text-muted">
                      Probe <span className="text-danger">Offline</span>
                    </span>
                  ) : this.state.probe_cst_sync_status.probe_status ==
                      "not_deployed" &&
                    this.state.probe_cst_sync_status.sync_status == 0 ? (
                    <span className="text-muted">
                      Probe not deployed{" "}
                      <span className="text-danger">Offline</span>
                    </span>
                  ) : this.state.probe_cst_sync_status.probe_status ==
                      "maintenance" &&
                    this.state.probe_cst_sync_status.sync_status == 0 ? (
                    <span className="text-muted">
                      Probe in maintenance{" "}
                      <span className="text-danger">Offline</span>
                    </span>
                  ) : null}
                </div>
                {this.state.probe_cst_sync_status.status ? (
                  <span>
                    <strong
                      className={
                        this.state.probe_cst_sync_status.status == "SYNCED"
                          ? "text-success"
                          : "text-orange"
                      }
                    >
                      {/*<span className={"mr-2 icon-" + (this.state.probe_cst_sync_status.status == 'SYNCED' ? 'cloud' : 'cloud-upload')}/>*/}
                      {this.state.probe_cst_sync_status.status == "SYNCED"
                        ? "Synchronized"
                        : "Waiting to push to probe"}
                    </strong>
                    <div>
                      (Last from{" "}
                      <strong>
                        {this.state.probe_cst_sync_status.last == "CLOUD"
                          ? "cloud"
                          : "probe"}
                      </strong>{" "}
                      at{" "}
                      {this.getAppContext()
                        .momentjs(this.state.probe_cst_sync_status.last_ts, "X")
                        .format("L LT")}
                      )
                    </div>
                  </span>
                ) : (
                  "-"
                )}
              </small>
            ) : null}
          </div>
        </Section>

        <Panel
          rounded
          className="mx-4 mb-4"
          bodyClassName="px-0 py-0"
          header={
            <div
              className={this.getAppContext().media.isMobile ? "" : "d-flex"}
            >
              <div
                className={
                  this.getAppContext().media.isMobile ? "mb-2" : "flex-grow-1"
                }
              >
                <div>ACTIVE MEASURES</div>
                <small className="text-muted">
                  Currently running measures list
                </small>
              </div>

              {this.getAppContext().isCloud() ? (
                <div>
                  {this.state.probe_cst_sync_status &&
                  this.state.probe_cst_sync_status.measures_conf == "manual" ? (
                    <div className="align-self-end">
                      <ReactOActionBar
                        align="right"
                        alignV="end"
                        className="p-0"
                      >
                        <ReactOButton
                          icon="plus-circle"
                          color="primary"
                          disabled={
                            (this.state.probe_cst_sync_status.measures_conf ==
                              "SD" &&
                              this.state.loading_action) ||
                            this.state.loading_probe_confs
                          }
                          onClick={(e) => {
                            if (e.altKey && e.shiftKey) {
                              this.setState(
                                {
                                  disableTags: false,
                                },
                                () => this._measure_editing_modal.open(),
                              );
                            } else {
                              this._measure_editing_modal.open();
                            }
                          }}
                        >
                          New measure
                        </ReactOButton>
                      </ReactOActionBar>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div>
                  <ReactOActionBar align="right" alignV="end" className="p-0">
                    <ReactOButton
                      icon="plus-circle"
                      color="primary"
                      disabled={
                        this.state.probe_cst_sync_status.measures_conf ==
                          "SD" && this.state.loading_action
                      }
                      onClick={() => {
                        this._measure_editing_modal.open();
                      }}
                    >
                      New measure
                    </ReactOButton>
                  </ReactOActionBar>
                </div>
              )}
            </div>
          }
        >
          <_LoadingWrapper
            minHeight
            loadingPlug={
              this.state.loading_probe_confs || this.state.loading_action
            }
          >
            <Section designType="wide">
              {this.state.forcing != undefined ? (
                <ReactOTable
                  thClassName="px-3 py-1"
                  tdClassName="align-middle px-3 py-2"
                  thDividers
                  compressed={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                  }
                  compressedRowRendering={(row_items) => {
                    return (
                      <div>
                        <div>{row_items.name.content}</div>
                        <Row className="mt-1">
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.essid.title}</strong>
                              </small>
                            </div>
                            {row_items.essid.content}
                          </Col>
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.test.title}</strong>
                              </small>
                            </div>
                            {row_items.test.content}
                          </Col>
                        </Row>
                        <Row className="mt-1">
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>
                                  {row_items.archived_at?.title || ""}
                                </strong>
                              </small>
                            </div>
                            {row_items.archived_at?.content || ""}
                          </Col>
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>
                                  {row_items.actions?.title || ""}
                                </strong>
                              </small>
                            </div>
                            {row_items.actions?.content || ""}
                          </Col>
                        </Row>
                      </div>
                    );
                  }}
                  defaultSort={[
                    {
                      data_key: "name",
                      order: "asc",
                    },
                    {
                      constrain: "down",
                      data_key: "status",
                      func: (value) => {
                        return value !== undefined;
                      },
                    },
                  ]}
                  onRowClick={
                    this.props.onItemClick
                      ? this.props.onItemClick
                      : (row_data) => {
                          //	console.log(row_data);
                        }
                  }
                  cols={[
                    {
                      title: "NAME",
                      data_key: "name",
                      width: "30",
                      sortable: true,
                    },
                    {
                      title: "NETWORK",
                      align: "center",
                      data_key: "essid",
                      width: "15",
                      sortable: true,
                    },
                    {
                      title: "TEST",
                      align: "center",
                      data_key: "test",
                      width: "15",
                      sortable: true,
                    },
                    {
                      title: "CONNECTION CRITERIA",
                      align: "center",
                      data_key: "connection_criteria",
                      width: "5",
                      sortable: true,
                    },
                    {
                      title: "ACTIONS",
                      align: "center",
                      data_key: "actions",
                      width: "25",
                    },
                  ]}
                  rows={(() => {
                    let _TMP = (
                      this.state.probe_confs.active
                        ? this.state.probe_confs.active
                        : []
                    ).map((_CURR_measure, _CURR_idx) => {
                      let status = _CURR_measure.paused
                        ? "/paused/"
                        : "/active/";
                      return {
                        name: {
                          value: _CURR_measure.name,
                          render: (
                            <Link
                              to={
                                "/" +
                                this.props.match.params.probeuid +
                                status +
                                _CURR_measure.cssid
                              }
                            >
                              <strong title="Measure result">
                                {_CURR_measure.name}
                              </strong>
                            </Link>
                          ),
                        },
                        essid: {
                          value: _CURR_measure.essid,
                          render: (
                            <span>
                              <span
                                className={
                                  "mr-1 icon-" +
                                  (/ethernet/i.test(_CURR_measure.essid)
                                    ? "ethernet"
                                    : "wifi")
                                }
                              />{" "}
                              {_CURR_measure.essid}
                            </span>
                          ),
                        },
                        test: {
                          value: _CURR_measure.test,
                          render: (
                            <div
                              id={
                                "tooltip_" +
                                _CURR_measure.test.replace(/\W/g, "") +
                                "_" +
                                _CURR_idx
                              }
                            >
                              {_CURR_measure.test}
                              <ReactOTooltip
                                placement="bottom"
                                target={
                                  "tooltip_" +
                                  _CURR_measure.test.replace(/\W/g, "") +
                                  "_" +
                                  _CURR_idx
                                }
                                text={
                                  this.state.tests_info
                                    ? this.state.tests_info[_CURR_measure.test]
                                      ? this.state.tests_info[
                                          _CURR_measure.test
                                        ].desc
                                      : "-"
                                    : "-"
                                }
                              />
                            </div>
                          ),
                        },
                        connection_criteria: _CURR_measure.bssid,
                        status: _CURR_measure.paused,
                        actions: {
                          render: (
                            <div
                              onClick={(e) => {
                                if (e.altKey && e.shiftKey) {
                                  this.setState({
                                    forcing: !this.state.forcing,
                                    disableTags: false,
                                  });
                                }
                              }}
                            >
                              {this.state.probe_cst_sync_status.measures_conf ==
                                "SD" && this.state.forcing == false ? (
                                <div className="p-4">
                                  {/* <ButtonGroup>
                                    <ReactOButton
                                      title="Modify"
                                      icon="eye-on"
                                      color="gray200"
                                      size="sm"
                                      onClick={() => {
                                        this._measure_editing_modal.open(_CURR_measure);
                                      }}
                                    /> */}
                                  <ReactOButton
                                    title="View"
                                    color="gray200"
                                    size="sm"
                                    icon="eye-on"
                                    onClick={() => {
                                      this._measure_editing_modal.open(
                                        _CURR_measure,
                                      );
                                    }}
                                    // disabled={true}
                                  >
                                    Software defined setup
                                  </ReactOButton>
                                  {/* </ButtonGroup> */}
                                  {_CURR_measure.paused ? (
                                    <span className="text-orange">Paused</span>
                                  ) : null}
                                </div>
                              ) : (
                                <div className="p-4">
                                  <ReactOActionBar align="center" padding="0">
                                    <ButtonGroup>
                                      <ReactOButton
                                        title="Modify"
                                        icon="pencil"
                                        color="gray200"
                                        size="sm"
                                        onClick={() => {
                                          this._measure_editing_modal.open(
                                            _CURR_measure,
                                          );
                                        }}
                                      />
                                      <ReactODropdown
                                        grouped
                                        color="gray200"
                                        size="sm"
                                        toggler={
                                          _CURR_measure.paused ? (
                                            <span className="text-orange">
                                              Paused
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              Running
                                            </span>
                                          )
                                        }
                                        options={[
                                          ...(_CURR_measure.paused
                                            ? [
                                                {
                                                  name: "Run",
                                                  icon: "play",
                                                  onClick: () => {
                                                    this.runProbeConf(
                                                      _CURR_measure,
                                                    );
                                                  },
                                                },
                                              ]
                                            : [
                                                {
                                                  name: "Pause",
                                                  icon: "pause",
                                                  onClick: () => {
                                                    this.pauseProbeConf(
                                                      _CURR_measure,
                                                    );
                                                  },
                                                },
                                              ]),
                                          ...(this.getAppContext().isCloud()
                                            ? [
                                                {
                                                  name: "Archived",
                                                  icon: "archive",
                                                  onClick: () => {
                                                    this.archiveProbeConf(
                                                      _CURR_measure,
                                                    );
                                                  },
                                                },
                                              ]
                                            : []),
                                          {
                                            name: "Delete",
                                            icon: "delete",
                                            onClick: () => {
                                              this.deleteProbeConf(
                                                _CURR_measure,
                                              );
                                            },
                                          },
                                        ]}
                                      />
                                    </ButtonGroup>
                                  </ReactOActionBar>
                                  <div className="mt-2 sub-title">
                                    {_CURR_measure.paused &&
                                      `Paused at ${this.getAppContext()
                                        .momentjs(_CURR_measure.paused, "X")
                                        .format("L LT")}`}
                                  </div>
                                </div>
                              )}
                            </div>
                          ),
                        },
                      };
                    });
                    return _TMP;
                  })()}
                />
              ) : null}
            </Section>
          </_LoadingWrapper>
        </Panel>

        {this.getAppContext().isCloud() && (
          <Panel
            rounded
            className="mx-4 mb-4"
            bodyClassName="p-0"
            header={
              <div>
                <div>ARCHIVED MEASURES</div>
                <small className="text-muted">
                  Archived measures. You can still edit and re-activate or
                  delete them
                </small>
              </div>
            }
          >
            <_LoadingWrapper
              minHeight
              loadingPlug={
                this.state.loading_probe_confs || this.state.loading_action
              }
            >
              <Section designType="wide">
                <ReactOTable
                  thClassName="px-3 py-1"
                  tdClassName="align-middle px-3 py-2"
                  thDividers
                  compressed={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                  }
                  compressedRowRendering={(row_items) => {
                    return (
                      <div>
                        <div>{row_items.name.content}</div>
                        <Row className="mt-1">
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.essid.title}</strong>
                              </small>
                            </div>
                            {row_items.essid.content}
                          </Col>
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.test.title}</strong>
                              </small>
                            </div>
                            {row_items.test.content}
                          </Col>
                        </Row>
                        <Row className="mt-1">
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.archived_at.title}</strong>
                              </small>
                            </div>
                            {row_items.archived_at.content}
                          </Col>
                          <Col>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.actions.title}</strong>
                              </small>
                            </div>
                            {row_items.actions.content}
                          </Col>
                        </Row>
                      </div>
                    );
                  }}
                  defaultSort={[
                    {
                      data_key: "name",
                      order: "asc",
                    },
                    //	{
                    //		constrain: 'down',
                    //		data_key: 'status',
                    //		func: (value) => {
                    //			return value != 0;
                    //		}
                    //	}
                  ]}
                  onRowClick={
                    this.props.onItemClick
                      ? this.props.onItemClick
                      : (row_data) => {
                          //	console.log(row_data);
                        }
                  }
                  cols={[
                    {
                      title: "NAME",
                      data_key: "name",
                      width: "25",
                      sortable: true,
                    },
                    {
                      title: "NETWORK",
                      align: "center",
                      data_key: "essid",
                      width: "15",
                      sortable: true,
                    },
                    {
                      title: "TEST",
                      align: "center",
                      data_key: "test",
                      width: "15",
                      sortable: true,
                    },
                    {
                      title: "ARCHIVED AT",
                      align: "center",
                      data_key: "archived_at",
                      width: "15",
                      sortable: true,
                    },
                    {
                      title: "ACTIONS",
                      align: "center",
                      data_key: "actions",
                      width: "25",
                    },
                  ]}
                  rows={(() => {
                    let _TMP = (
                      this.state.probe_confs.archived
                        ? this.state.probe_confs.archived
                        : []
                    ).map((_CURR_measure, _CURR_idx) => {
                      return {
                        name: {
                          value: _CURR_measure.name,
                          render: (
                            <Link
                              to={
                                "/" +
                                this.props.match.params.probeuid +
                                "/archived/" +
                                _CURR_measure.cssid
                              }
                            >
                              <strong>{_CURR_measure.name}</strong>
                            </Link>
                          ),
                        },
                        essid: {
                          value: _CURR_measure.essid,
                          render: (
                            <span>
                              <span
                                className={
                                  "mr-1 icon-" +
                                  (/ethernet/i.test(_CURR_measure.essid)
                                    ? "ethernet"
                                    : "wifi")
                                }
                              />{" "}
                              {_CURR_measure.essid}
                            </span>
                          ),
                        },
                        test: {
                          value: _CURR_measure.test,
                          render: (
                            <div
                              id={
                                "tooltip_" +
                                _CURR_measure.test.replace(/\W/g, "") +
                                "_" +
                                _CURR_idx
                              }
                            >
                              {_CURR_measure.test}
                              {this.state.description &&
                                this.state.description[_CURR_measure.test] && (
                                  <ReactOTooltip
                                    placement="bottom"
                                    target={
                                      "tooltip_" +
                                      _CURR_measure.test.replace(/\W/g, "") +
                                      "_" +
                                      _CURR_idx
                                    }
                                    text={
                                      this.state.description[_CURR_measure.test]
                                    }
                                  />
                                )}
                            </div>
                          ),
                        },
                        archived_at: {
                          render: (
                            <div className="text-center">
                              <div
                                id={
                                  "tp_archived_" +
                                  _CURR_measure.test.replace(/\W/g, "") +
                                  "_" +
                                  _CURR_idx
                                }
                                className={
                                  this.getArchivedAlert(_CURR_measure.archived)
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {_CURR_measure?.archived
                                  ? this.getAppContext()
                                      .momentjs(_CURR_measure.archived, "X")
                                      .format("L LT")
                                  : "-"}
                                {this.getArchivedAlert(
                                  _CURR_measure.archived,
                                ) && (
                                  <ReactOTooltip
                                    placement="bottom"
                                    target={
                                      "tp_archived_" +
                                      _CURR_measure.test.replace(/\W/g, "") +
                                      "_" +
                                      _CURR_idx
                                    }
                                    text="This measure has been archived more than 1 year ago."
                                  />
                                )}
                              </div>
                              {/* {this.getArchivedAlert(_CURR_measure.archived) && (
                                <div
                                  title="This measure has been archived more than 1 year ago."
                                  className="icon-info align-self-center px-1"
                                />
                              )} */}
                            </div>
                          ),
                        },
                        actions: {
                          render: (
                            <div
                              onClick={(e) => {
                                if (e.altKey && e.shiftKey) {
                                  this.setState({
                                    forcing: !this.state.forcing,
                                    disableTags: false,
                                  });
                                }
                              }}
                            >
                              {this.state.probe_cst_sync_status.measures_conf ==
                                "SD" && this.state.forcing == false ? (
                                <div className="p-4">
                                  {/* <ButtonGroup>
                                <ReactOButton
                                  title="Modify"
                                  icon="eye-on"
                                  color="gray200"
                                  size="sm"
                                  onClick={() => {
                                    this._measure_editing_modal.open(_CURR_measure);
                                  }}
                                /> */}
                                  <ReactOButton
                                    title="View"
                                    color="gray200"
                                    size="sm"
                                    icon="eye-on"
                                    onClick={() => {
                                      this._measure_editing_modal.open(
                                        _CURR_measure,
                                      );
                                    }}
                                    // disabled={true}
                                  >
                                    Software defined setup
                                  </ReactOButton>
                                  {/* </ButtonGroup> */}
                                  {_CURR_measure.paused ? (
                                    <span className="text-orange">Paused</span>
                                  ) : null}
                                </div>
                              ) : (
                                <div className="d-flex align-items-center">
                                  <ReactOActionBar align="center" padding="0">
                                    <ButtonGroup>
                                      <ReactOButton
                                        title="View measure settings"
                                        icon="eye-on"
                                        color="gray200"
                                        size="sm"
                                        onClick={() => {
                                          this._measure_editing_modal.open(
                                            _CURR_measure,
                                          );
                                        }}
                                      />
                                      <ReactODropdown
                                        grouped
                                        color="gray200"
                                        size="sm"
                                        toggler="Actions"
                                        options={[
                                          {
                                            name: "Clone",
                                            icon: "replay",
                                            onClick: () => {
                                              this.resumeProbeConf(
                                                _CURR_measure,
                                              );
                                            },
                                          },
                                          {
                                            name: "Delete",
                                            icon: "delete",
                                            onClick: () => {
                                              this.deleteProbeConf(
                                                _CURR_measure,
                                              );
                                            },
                                          },
                                        ]}
                                      />
                                    </ButtonGroup>
                                  </ReactOActionBar>
                                </div>
                              )}
                            </div>
                          ),
                        },
                      };
                    });
                    return _TMP;
                  })()}
                />
              </Section>
            </_LoadingWrapper>
          </Panel>
        )}

        {/*
//////////////////////////
//		Editing Modal
////////////////////////
*/}

        <ReactOModal
          keyboard={this.state.loading_cve}
          modalId="measureEditing"
          size={this.state.editingModalSize}
          loading={this.state.loading_cve}
          fadeSpinner
          loadingText={
            this._measure_editing_form?.getFormData().net_type != "cve"
              ? false
              : "yes"
          }
          onControllerReady={(modal_context) => {
            this._measure_editing_modal = modal_context;
          }}
          onModalMounted={(data) => {
            this._cloneOriginalName = data?.name || "";
            if (this.state._cloneMode) {
              this.setState({ _cloneMode: false });
            }
            if (data && data.tags && data.tags.length > 0) {
              const uniqueTags = [...new Set(data.tags)];
              const tagsList = uniqueTags.map((label) => ({
                label,
                value: label.toLowerCase().replace(/\W/g, ""),
              }));
              this.setState({ tagsList }, () => {
                this.currTimeslot = data?.timeslot || false;
                this._measure_editing_form.init(data ? data : {});
              });
            } else {
              if (
                data &&
                this.getAppContext().authHandler.getAccountData()
                  .smart_notifications &&
                this.getAppContext().authHandler.getAccountData()
                  .smart_notifications == "yes"
              ) {
                data.tags = [];
              }
              this.currTimeslot = data?.timeslot || false;
              this._measure_editing_form.init(data ? data : {});
            }
            // this.setState({ currTimeslot: data?.timeslot || false }, () => {
            //   this._measure_editing_form.init(data ? data : {});
            // });
          }}
          onModalUnmounted={() => {
            // this.currTimeslot = false;
            this.setState(
              {
                editingModalSize: "lg",
                cveScriptResult: null,
                disableTags: true,
                tagsList: [],
                _cloneMode: false,
              },
              () => {
                if (this.props.match.params.initselection) {
                  this.getAppContext().redirectTo(
                    this.props.location.state.prevPath,
                  );
                }
              },
            );
          }}
          header={(data) => {
            if (this.state._cloneMode && data) {
              return `Clone measure ${data.name || ""}`;
            }
            return data
              ? data.archived
                ? "Measure"
                : `Edit measure ${data.name || ""}`
              : "Create new measure";
          }}
          body={(data) => {
            const currTestInfo = data
              ? this.state.tests_info?.[data.test]
              : null;
            const { hw } = this.state.probe_capabilities || {};
            const testNotPermitted =
              currTestInfo?.excludedHW?.includes(hw) || false;
            const isFieldDisabled =
              data?.archived ||
              (!this.state.forcing &&
                (this.state.probe_cst_sync_status?.measures_conf == "SD" ||
                  testNotPermitted));
            return (
              <ReactOForm
                // submitOnEnterKey
                onFormDataChange={(form_data) => {
                  this.forceUpdate();
                }}
                unsavedWarning={true}
                // ignoreClick={true}
                onControllerReady={(form_controller) => {
                  this._measure_editing_form = form_controller;
                }}
                /////////////////////////////////////
                //		Form pre initializations

                preInit={(form_data) => {
                  // console.log(
                  //   "this.state.notifications.measures",
                  //   this.state.notifications.measures,
                  // );
                  // console.log("form_data", form_data);
                  if (Object.keys(form_data).length > 0) {
                    if (
                      (!form_data.notifications ||
                        (form_data.notifications &&
                          !form_data.notifications.enable)) &&
                      this.state.notifications?.measures
                    ) {
                      form_data.notifications = { enable: "yes" };
                    }
                    if (
                      form_data.timeslot &&
                      parseInt(form_data.timeslot) > "0"
                    ) {
                      form_data.timeslot_enabled = "yes";
                    } else {
                      form_data.timeslot = "";
                      form_data.timeslot_enabled = "no";
                    }
                    if (form_data.test != "CVE") {
                      if (form_data.sync != "") {
                        form_data.supportsSync = "yes";
                      } else {
                        form_data.supportsSync = false;
                      }
                      if (form_data.essid == "Ethernet") {
                        form_data.net_type = "ethernet";
                      }
                      if (form_data.eap_cert || form_data.eap_pkey) {
                        form_data.auth = "PEAP";
                        form_data.auth_mod = "EAP-TLS";
                      }

                      if (form_data.eapanonymousidentity) {
                        form_data.eapanonymousidentity_enabled = "yes";
                      }

                      if (form_data.httpproxy) {
                        form_data.httpproxy_enabled = "yes";
                      }
                      if (form_data.schedule && !form_data.schedule.length) {
                        delete form_data.schedule;
                      }
                    } else {
                      form_data.net_type = "cve";
                      const test = form_data.extraParameters?.cve_test;
                      const cve_debug =
                        form_data.extraParameters?.cve_debug || "no";
                      const decoded = base64ToUint8Array(test);
                      if (decoded) {
                        try {
                          const decompressedTest =
                            decompressGzipFromBase64(decoded);
                          form_data.cve_test_script = decompressedTest || "";
                        } catch (err) {
                          form_data.cve_test_script = test;
                        }
                      } else {
                        form_data.cve_test_script = test;
                      }
                      if (cve_debug == "yes") {
                        form_data.cve_debug = "yes";
                      }
                    }
                    if (form_data.tags && form_data.tags.length > 0) {
                      let tags = form_data.tags
                        .sort((a, b) =>
                          a.localeCompare(b, "it", { sensitivity: "base" }),
                        )
                        .join(", ");
                      form_data.tags = tags;
                    }
                  } else {
                    let firstTest = [
                      ...this.state.probe_tests.s_tests,
                      ...this.state.probe_tests.c_tests,
                    ].filter((elem) => {
                      return elem.RJ45 == undefined || elem.RJ45 == "no";
                    })[0];
                    if (
                      firstTest.supportsSync &&
                      firstTest.supportsSync != "no"
                    ) {
                      form_data.supportsSync = "yes";
                    } else {
                      form_data.supportsSync = false;
                    }
                    form_data.tags = [];
                  }

                  return form_data;
                }}
                /////////////////////////////////////
                //		Form pre submit

                preSubmit={(form_data) => {
                  // console.log("form_data", form_data);
                  if (form_data.test && form_data.net_type != "cve") {
                    if (
                      !this.state.tests_info[form_data.test]?.extraParameters &&
                      form_data.extraParameters
                    ) {
                      delete form_data.extraParameters;
                    }

                    if (
                      this.state.tests_info &&
                      this.state.tests_info[form_data.test]?.extraParameters &&
                      form_data.extraParameters
                    ) {
                      Object.keys(form_data.extraParameters).forEach(
                        (param) => {
                          if (
                            !this.state.tests_info[form_data.test]
                              .extraParameters[param]
                          ) {
                            delete form_data.extraParameters[param];
                          }
                        },
                      );
                    }

                    if (form_data.net_type == "ethernet") {
                      form_data.essid = "Ethernet";
                      form_data.bssid = "RJ45";
                    }
                    if (form_data.auth_mod == "EAP-TLS") {
                      form_data.auth = "EAP";
                    }

                    if (form_data.supportsSync == "yes") {
                      // form_data.sync = this.getAppContext()
                      //   .getApiStoreService()
                      //   .getCluster();
                      form_data.sync =
                        this.getAppContext().authHandler.getAccountData().cluster;
                    } else {
                      form_data.sync = "";
                    }

                    if (form_data.name == "") {
                      form_data.name =
                        (form_data.hidden == "yes"
                          ? form_data.net_name
                          : form_data.essid) +
                        " with test " +
                        form_data.test;
                    }
                    if (form_data.schedule) {
                      form_data.schedule.forEach((_C_value, _C_idx) => {
                        form_data.schedule[_C_idx] =
                          _C_value == "" ? undefined : parseInt(_C_value);
                      });
                      form_data.schedule = form_data.schedule.filter(
                        (value) => {
                          return value !== undefined;
                        },
                      );
                    }

                    if (
                      this.state.tests_info[form_data.test] &&
                      this.state.tests_info[form_data.test].timeout &&
                      this.state.tests_info[form_data.test].timeout != null
                    ) {
                      form_data.timeout =
                        this.state.tests_info[form_data.test].timeout;
                    }

                    if (
                      this.state.tests_info[form_data.test] &&
                      this.state.tests_info[form_data.test].timeout &&
                      this.state.tests_info[form_data.test].timeout == null &&
                      form_data.timeout
                    ) {
                      delete form_data.timeout;
                    }
                  }

                  // CVE
                  if (
                    form_data.net_type == "cve" &&
                    form_data.cve_test_script
                  ) {
                    // ENCODE GZIP
                    const gzip = compressGzip(form_data.cve_test_script);
                    const cve_test = encodeBase64(gzip);
                    const cve_debug = form_data.cve_debug;
                    // DECODE
                    // const compressedData = base64ToUint8Array(base64script);
                    // const decompressed =
                    //   decompressGzipFromBase64(compressedData);

                    delete form_data.cve_test_script;
                    if (form_data.extraParameters) {
                      delete form_data.extraParameters;
                    }

                    form_data.extraParameters = { cve_test, cve_debug };
                    form_data.bssid = "RJ45";
                    form_data.essid = "Ethernet";
                    form_data.test = "CVE";
                    form_data.label = "LOC1";
                  }

                  // HANDLE TIMESLOT
                  if (form_data.timeslot_enabled == "no") {
                    form_data.timeslot = "0";
                    // this.currTimeslot = false;
                  }

                  if (
                    form_data.tags &&
                    form_data.tags.length > 0 &&
                    typeof form_data.tags === "string"
                  ) {
                    // console.log("form_data.tags", form_data.tags);
                    let tags = form_data.tags
                      .split(",")
                      .map((tag) => tag.trim())
                      .filter(Boolean)

                      .sort((a, b) =>
                        a.localeCompare(b, "it", { sensitivity: "base" }),
                      );
                    form_data.tags = tags;
                  }

                  return form_data;
                }}
                onSubmit={(form_data, cb) => {
                  if (form_data.label == "None") {
                    delete form_data.label;
                  }
                  delete form_data.supportsSync;
                  if (this.state._cloneMode) {
                    delete form_data.configured;
                    delete form_data.archived;
                    delete form_data.paused;
                    delete form_data.cssid;
                    this.createProbeConf(form_data, (status, resp) => {
                      if (status === "OK" || status === true) {
                        this.setState({ _cloneMode: false });
                      }
                      if (cb) cb(status, resp);
                    });
                  } else if (data) {
                    this.saveProbeConfs(form_data, cb);
                  } else {
                    this.createProbeConf(form_data, cb);
                  }
                }}
              >
                <ReactOFormInput type="hidden" data_key="hidden" default="no" />
                <ReactOFormInput type="hidden" data_key="timeout" />

                {/*
////////////////////////////////////////
//		INPUT (switch) - Network type
*/}

                <Row className="pb-2 border-bottom border-2 border-primary">
                  <Col xs={12} className="">
                    <strong>MEASURE</strong>
                  </Col>
                </Row>
                <Row className="mt-3 px-4">
                  <Col xs={12} sm={6}>
                    <ReactOFormInput
                      type="radio-buttons"
                      auxiliary
                      data_key="net_type"
                      label="Measure type"
                      help={
                        <small>
                          {(this.state.probe_capabilities &&
                            this.state.probe_capabilities.ethernet === "no") ||
                          (this.state.tests_info &&
                            this.state.tests_info.countOccurrences &&
                            this.state.tests_info.countOccurrences.total &&
                            this.state.tests_info.countOccurrences.total
                              .ethernet === 0) ? (
                            <div>
                              Ethernet interface not available on this device
                            </div>
                          ) : (
                            <div>
                              <strong>Measure type</strong> cannot be modified
                              after measure creation
                            </div>
                          )}
                        </small>
                      }
                      selectedColor="primary"
                      justified
                      default="wifi"
                      disabled={
                        data ||
                        this.state?.probe_capabilities?.ethernet === "no" ||
                        (this.state.tests_info.countOccurrences &&
                          this.state.tests_info.countOccurrences.total &&
                          this.state.tests_info.countOccurrences.total
                            .ethernet === 0)
                          ? true
                          : false
                      }
                      onOptionSelected={(form_ctrl, new_value) => {
                        // form_ctrl.handleFormChange("supportsSync", false);

                        // if (
                        //   this.state.tests_info[form_ctrl.getEntry("test")]
                        //     .extraParameters
                        // ) {
                        //   Object.keys(
                        //     this.state.tests_info[form_ctrl.getEntry("test")]
                        //       .extraParameters
                        //   ).forEach((params, id) => {
                        //     form_ctrl.destroyEntry("extraParameters." + params);
                        //     form_ctrl.unregisterInput("extraParameters." + params);
                        //   });
                        // }

                        form_ctrl.handleFormChange("net_type", new_value);
                        form_ctrl.handleFormChange(
                          "notifications.threshold",
                          new_value == "wifi" ? "50" : "4",
                        );
                        form_ctrl.handleFormChange(
                          "essid",
                          new_value == "wifi" ? false : "Ethernet",
                        );
                        form_ctrl.handleFormChange(
                          "auth",
                          new_value == "wifi" ? "" : "",
                        );
                        form_ctrl.handleFormChange("hidden", "no");
                        form_ctrl.handleFormChange("test", false); // inizialize

                        let currTest = form_ctrl.getEntry("test");
                        const extraParameters =
                          this.state.tests_info[currTest].extraParameters;

                        // Reset extraParamters
                        if (extraParameters) {
                          Object.keys(extraParameters).forEach((params) => {
                            const { default: defaultValue } =
                              extraParameters[params] || {};
                            let dataKey = `extraParameters.${params}`;
                            form_ctrl.setEntry(
                              dataKey,
                              defaultValue !== undefined ? defaultValue : "",
                            );
                          });
                        }

                        form_ctrl.handleFormChange(
                          "c_test",
                          this.state.tests_info.countOccurrences.s_tests[
                            new_value
                          ] > 0
                            ? "no"
                            : "yes",
                        );
                        if (new_value == "cve") {
                          form_ctrl.handleFormChange(
                            "name",
                            `CVE test ${this.getAppContext().momentjs().unix()}`,
                          );
                          form_ctrl.handleFormChange("timeslot_enabled", "yes");
                          form_ctrl.handleFormChange("timeslot", "60");
                        } else if (
                          form_ctrl.getEntry("custom_mea_name") == "no"
                        ) {
                          let _CURR_essid = form_ctrl.getEntry("essid");
                          _CURR_essid =
                            _CURR_essid == "_ALIAS_net_name"
                              ? form_ctrl.getEntry("net_name") || ""
                              : _CURR_essid || "";
                          form_ctrl.handleFormChange(
                            "name",
                            (new_value == "wifi" ? _CURR_essid : "Ethernet") +
                              " with test " +
                              form_ctrl.getEntry("test"),
                          );
                        }

                        form_ctrl.handleFormChange(
                          "supportsSync",
                          this.state.probe_tests[
                            form_ctrl.getEntry("c_test") == "yes"
                              ? "c_tests"
                              : "s_tests"
                          ].find((value) => {
                            return (
                              value.name ==
                              this._measure_editing_form.getEntry("test")
                            );
                          })?.supportsSync &&
                            this.state.probe_tests[
                              form_ctrl.getEntry("c_test") == "yes"
                                ? "c_tests"
                                : "s_tests"
                            ].find((value) => {
                              return (
                                value.name ==
                                this._measure_editing_form.getEntry("test")
                              );
                            }).supportsSync != "no"
                            ? "yes"
                            : false,
                        );
                      }}
                      options={this.getNetType()}
                    />
                  </Col>

                  {/*
/////////////////////////////////////////
//		INPUT (select) - Network ESSID
*/}
                  <Col xs={12} sm={6} className="mt-3 mt-sm-0">
                    <ReactOFormInput
                      type="select"
                      data_key="essid"
                      label="Network / Essid"
                      help={
                        <small>
                          <strong>Net / Essid</strong> cannot be modified after
                          measure creation
                        </small>
                      }
                      noSelectionLabel="Select a network..."
                      scrollable
                      size="md"
                      //	default={1}
                      disabled={data?.archived || (data ? true : false)}
                      defineIf={(form_data) => {
                        return form_data.net_type == "wifi";
                      }}
                      onOpen={() => {
                        this.callsSet.call("probe_network_scan");
                      }}
                      aliases={[
                        {
                          applyIf: (value, form_data) => {
                            return form_data.hidden == "yes";
                          },
                          to: "net_name",
                        },
                      ]}
                      onOptionSelect={(form_ctrl, selected_value) => {
                        form_ctrl.handleFormChange(
                          "essid",
                          selected_value.essid
                            ? selected_value.essid
                            : selected_value,
                        );
                        form_ctrl.handleFormChange(
                          "hidden",
                          selected_value == "_ALIAS_net_name" ? "yes" : "no",
                        );
                        form_ctrl.handleFormChange(
                          "auth",
                          selected_value == "_ALIAS_net_name"
                            ? ""
                            : selected_value.auth
                              ? selected_value.auth.includes("IEEE 802.1X")
                                ? "PEAP"
                                : selected_value.auth
                              : "",
                        );
                        if (form_ctrl.getEntry("custom_mea_name") == "no") {
                          let _CURR_essid = form_ctrl.getEntry("essid");
                          _CURR_essid =
                            _CURR_essid == "_ALIAS_net_name"
                              ? form_ctrl.getEntry("net_name") || ""
                              : _CURR_essid || "";
                          form_ctrl.handleFormChange(
                            "name",
                            _CURR_essid +
                              " with test " +
                              form_ctrl.getEntry("test"),
                          );
                        }
                      }}
                      options={(form_data) => {
                        let _RET = [];
                        if (data && form_data.hidden == "no") {
                          _RET.push({
                            name: form_data.essid,
                            value: form_data.essid,
                          });
                        } else {
                          [
                            (item_idx) => {
                              return (
                                <div
                                  key={item_idx}
                                  className="dropdown-title-divider"
                                >
                                  <Row noGutters>
                                    <Col
                                      xs={6}
                                      className="d-flex align-items-center"
                                    >
                                      <strong>Networks list</strong>
                                    </Col>
                                    <Col xs={6}>
                                      <ReactOActionBar
                                        align="right"
                                        padding="0"
                                      >
                                        <LoadingSpin
                                          loadingPlug={
                                            this.state
                                              .loading_probe_network_scan
                                          }
                                          className="d-flex align-items-center"
                                          bounceSpinner
                                        />
                                        <ReactOButton
                                          icon="refresh"
                                          color="gray200"
                                          size="sm"
                                          preventDefault
                                          onClick={() => {
                                            this.callsSet.call(
                                              "probe_network_scan",
                                            );
                                          }}
                                        />
                                      </ReactOActionBar>
                                    </Col>
                                  </Row>
                                </div>
                              );
                            },
                            ...(() => {
                              let _seen_essid = [];
                              return this.state.probe_network_scan &&
                                this.state.probe_network_scan.length > 0
                                ? this.state.probe_network_scan.map(
                                    (_CURR_net, _CURR_idx) => {
                                      let _return = _seen_essid.includes(
                                        _CURR_net.essid,
                                      )
                                        ? null
                                        : {
                                            name: _CURR_net.essid,
                                            value: _CURR_net,
                                            active: (value) => {
                                              return value == _CURR_net.essid;
                                            },
                                            disabled: _CURR_net.hidden
                                              ? true
                                              : false,
                                            render: () => {
                                              return (
                                                <div
                                                  key={_CURR_idx}
                                                  className="d-flex"
                                                >
                                                  <div
                                                    className={
                                                      "flex-grow-1 pr-3" +
                                                      (_CURR_net.hidden
                                                        ? " "
                                                        : "")
                                                    }
                                                  >
                                                    {_CURR_net.hidden
                                                      ? "[ HIDDEN ]"
                                                      : _CURR_net.essid}
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "24px",
                                                      height: "24px",
                                                    }}
                                                  >
                                                    {_CURR_net.auth != "" ? (
                                                      <span className="icon-lock" />
                                                    ) : null}
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "18px",
                                                      height: "18px",
                                                      marginTop: "3px",
                                                      background:
                                                        "url(" +
                                                        this.getAppContext()
                                                          .conf.PUBLIC_PATH +
                                                        "images/wifi_level_sprite.png) " +
                                                        (_CURR_net.level <= -80
                                                          ? "0"
                                                          : _CURR_net.level <=
                                                              -60
                                                            ? "-18px"
                                                            : "-36px") +
                                                        " 0 / 54px 18px",
                                                    }}
                                                  />
                                                </div>
                                              );
                                            },
                                          };
                                      _seen_essid.push(_CURR_net.essid);
                                      return _return;
                                    },
                                  )
                                : [
                                    (item_idx) => {
                                      return (
                                        <div
                                          key={item_idx}
                                          className="px-3 pt-1 pb-2 mb-2 text-muted text-center"
                                        >
                                          No network found
                                        </div>
                                      );
                                    },
                                  ];
                            })(),
                            "divider",
                          ].forEach((_CURR) => {
                            _RET.push(_CURR);
                          });
                        }
                        _RET.push({
                          name: "Other network...",
                          value: "_ALIAS_net_name",
                        });
                        return _RET;
                      }}
                      validators={[
                        {
                          func: (value) => {
                            return value !== undefined && /^.+$/.test(value);
                          },
                          invalid_text: "Select a network",
                        },
                      ]}
                    />
                  </Col>
                </Row>

                {/*
//////////////////////////////////////
//		INPUT (text) - Network name
*/}
                <Row className="px-4">
                  <Col xs={12} sm={6}>
                    <ReactOFormInput
                      className="mt-3"
                      type="text"
                      data_key="net_name"
                      aliasFor="essid"
                      label="Network name"
                      size="md"
                      default=""
                      autofocus
                      disabled={data?.archived || (data ? true : false)}
                      onValueChange={(form_ctrl, new_value) => {
                        form_ctrl.handleFormChange("net_name", new_value);
                        if (form_ctrl.getEntry("custom_mea_name") == "no") {
                          let _CURR_essid = form_ctrl.getEntry("essid");
                          _CURR_essid =
                            _CURR_essid == "_ALIAS_net_name"
                              ? form_ctrl.getEntry("net_name") || ""
                              : _CURR_essid || "";
                          form_ctrl.handleFormChange(
                            "name",
                            _CURR_essid +
                              " with test " +
                              form_ctrl.getEntry("test"),
                          );
                        }
                      }}
                      validators={[
                        {
                          func: (value) => {
                            return /^.+$/.test(value);
                          },
                          invalid_text: "Type a valid value",
                        },
                      ]}
                    />
                  </Col>
                </Row>

                {/*
/////////////////////////////////////////////////
//		INPUT (select) - Authentication type
*/}
                <Row className="px-4">
                  {" "}
                  {/*<Row className="bg-gray200 border-bottom border-4 border-gray400"}>*/}
                  <Col xs={12}>
                    {this._measure_editing_form?.getFormData().net_type !=
                    "cve" ? (
                      <Row>
                        <Col xs={12} sm={6}>
                          <ReactOFormInput
                            className="mt-3 mb-3"
                            type="select"
                            data_key="auth"
                            label="Authentication type"
                            size="md"
                            disabled={isFieldDisabled}
                            disabledIf={(form_data) => {
                              return (
                                form_data.essid !== undefined &&
                                form_data.hidden == "no"
                              );
                            }}
                            defineIf={(form_data) => {
                              let _TMP_testData =
                                this.state.probe_tests &&
                                this.state.probe_tests[
                                  form_data.c_test == "yes"
                                    ? "c_tests"
                                    : "s_tests"
                                ] &&
                                this.state.probe_tests[
                                  form_data.c_test == "yes"
                                    ? "c_tests"
                                    : "s_tests"
                                ].find((value) => {
                                  return value.name == form_data.test;
                                });

                              if (
                                _TMP_testData?.supportsAuthentication == "no"
                              ) {
                                return false;
                              }

                              if (
                                form_data.net_type != "ethernet" &&
                                form_data.essid !== undefined
                              ) {
                                return true;
                              }
                            }}
                            onInputWillUndefine={(form_ctrl) => {
                              let _TMP_currValue = form_ctrl.getEntry("auth");
                              if (_TMP_currValue !== undefined) {
                                this._PREV_authValue = _TMP_currValue;
                              }
                            }}
                            onInputDidDefine={(form_ctrl) => {
                              if (this._PREV_authValue) {
                                form_ctrl.handleFormChange(
                                  "auth",
                                  this._PREV_authValue,
                                );
                                this._PREV_authValue = undefined;
                              }
                            }}
                            default=""
                            options={(form_data) => {
                              const options = this.getAuthOptions(form_data);
                              return options;
                            }}
                          />
                        </Col>
                        <Col xs={12} sm={6}>
                          <ReactOFormInput
                            className="mt-sm-3 mb-3"
                            disabled={isFieldDisabled}
                            auxiliary
                            type="select"
                            data_key="auth_mod"
                            label="Authentication modality"
                            size="md"
                            defineIf={(form_data) => {
                              return (
                                form_data.auth !== undefined &&
                                form_data.auth != "" &&
                                form_data.auth != "PSK" &&
                                form_data.auth != "SAE"
                              );
                            }}
                            default="PEAP"
                            onOptionSelect={(form_ctrl, selected_value) => {
                              //	if (data) {
                              //		this.callsSet.call('measure_certificates', {
                              //			data_input: {
                              //				measureid: data.cssid
                              //			}
                              //		})
                              //	}
                              form_ctrl.handleFormChange(
                                "auth_mod",
                                selected_value,
                              );
                            }}
                            options={(form_data) => {
                              return [
                                { name: "PEAP", value: "PEAP" },
                                { name: "EAP-TLS", value: "EAP-TLS" },
                              ];
                            }}
                          />
                        </Col>
                      </Row>
                    ) : null}

                    <Row>
                      <Col xs={12} sm={6}>
                        {this._measure_editing_form &&
                        this._measure_editing_form.getFormData().auth ==
                          "PEAP" &&
                        this._measure_editing_form.getFormData().auth_mod ==
                          "EAP-TLS" ? (
                          <div>
                            <Label>Certificate</Label>
                            {/*
														<_LoadingWrapper
															minHeight
															loadingPlug={this.state.measure_certificates_loading}
														>
														*/}
                            {this._measure_editing_form.getFormData()
                              .eap_cert &&
                            this._measure_editing_form.getFormData().eap_cert
                              .length &&
                            this._measure_editing_form.getFormData().eap_cert[0]
                              .uploaded ? (
                              <div>
                                <Panel
                                  rounded
                                  bodyClassName="p-2 d-flex align-items-center"
                                >
                                  <div className="flex-grow-1 text-truncate">
                                    {
                                      this._measure_editing_form.getFormData()
                                        .eap_cert_fname
                                    }
                                  </div>
                                  <div>
                                    <ReactOButton
                                      icon="cancel"
                                      color="light"
                                      size="sm"
                                      disabled={isFieldDisabled}
                                      onClick={() => {
                                        //	remove_action(_C_idx);
                                        this._measure_editing_form.setEntry(
                                          "eap_cert",
                                          [],
                                        );
                                        this._measure_editing_form.setEntry(
                                          "eap_cert_fname",
                                          false,
                                        );
                                      }}
                                    />
                                  </div>
                                </Panel>
                              </div>
                            ) : (
                              <div className="text-muted text-center mb-3">
                                <small>
                                  <strong>No certificate uploaded</strong>
                                </small>
                              </div>
                            )}
                            {/*
														</_LoadingWrapper>
														*/}
                          </div>
                        ) : null}
                        <ReactOFormInput
                          className="mb-2"
                          type="upload"
                          data_key="eap_cert"
                          size="md"
                          disabled={isFieldDisabled}
                          defineIf={(form_data) => {
                            return (
                              form_data.auth == "PEAP" &&
                              form_data.auth_mod == "EAP-TLS"
                            );
                          }}
                          showIf={(form_data) => {
                            return (
                              (form_data.eap_cert &&
                                form_data.eap_cert.length &&
                                !form_data.eap_cert[0].uploaded) ||
                              (form_data.eap_cert &&
                                form_data.eap_cert.length == 0) ||
                              !data
                            );
                          }}
                          maxUploads={1}
                          onDropped={(form_ctrl, uploading_queue, cb) => {
                            if (uploading_queue.length) {
                              this.callsSet.call("parse_measure_certificate", {
                                data_input: {
                                  cert_file: uploading_queue[0],
                                },
                                on_success: (
                                  response_status,
                                  response_data,
                                ) => {
                                  //	if (response_data[0].data.is_valid) {
                                  //		delete(uploading_queue[0].content);
                                  //	}
                                  uploading_queue[0] = {
                                    ...uploading_queue[0],
                                    ...response_data[0].data,
                                  };
                                  if (cb) cb(uploading_queue);
                                },
                              });
                            }
                          }}
                          validators={[
                            {
                              func: (value) => {
                                return value.length > 0;
                              },
                              invalid_text: "Load a certificate",
                            },
                            {
                              func: (value) => {
                                return (
                                  value[0].is_valid === undefined ||
                                  value[0].is_valid == 1
                                );
                              },
                              invalid_text: "Choose a valid x509 certificate",
                            },
                          ]}
                          queueRenderFunction={(data, remove_action) => {
                            return (
                              <div className={data.length ? "p-2" : ""}>
                                <ReactOTable
                                  tdClassName="align-middle"
                                  size="sm"
                                  thDividers
                                  cols={[
                                    {
                                      data_key: "filename",
                                      width: "90",
                                      sortable: true,
                                    },
                                    {
                                      align: "right",
                                      data_key: "action",
                                      width: "10",
                                    },
                                  ]}
                                  rows={(() => {
                                    let _TMP = (data || []).map(
                                      (_C_file, _C_idx) => {
                                        return {
                                          filename: {
                                            value: _C_file.filename,
                                            render: (
                                              <div>
                                                {_C_file.filename}{" "}
                                                {_C_file.is_valid !== undefined
                                                  ? _C_file.is_valid
                                                    ? "(OK)"
                                                    : "(KO)"
                                                  : null}
                                              </div>
                                            ),
                                          },
                                          action: {
                                            render: (
                                              <ReactOButton
                                                icon="cancel"
                                                color="light"
                                                size="sm"
                                                onClick={() => {
                                                  remove_action(_C_idx);
                                                }}
                                              />
                                            ),
                                          },
                                        };
                                      },
                                    );
                                    return _TMP;
                                  })()}
                                />
                              </div>
                            );
                          }}
                        />
                      </Col>
                      <Col xs={12} sm={6} className="mt-3 mt-sm-0">
                        {this._measure_editing_form &&
                        this._measure_editing_form.getFormData().auth ==
                          "PEAP" &&
                        this._measure_editing_form.getFormData().auth_mod ==
                          "EAP-TLS" ? (
                          <div>
                            <Label>Private key</Label>
                            {/*
														<_LoadingWrapper
															minHeight
															loadingPlug={this.state.measure_certificates_loading}
														>
														*/}
                            {this._measure_editing_form.getFormData()
                              .eap_pkey &&
                            this._measure_editing_form.getFormData().eap_pkey
                              .length &&
                            this._measure_editing_form.getFormData().eap_pkey[0]
                              .uploaded ? (
                              <div>
                                <Panel
                                  rounded
                                  bodyClassName="p-2 d-flex align-items-center"
                                >
                                  <div className="flex-grow-1 text-truncate">
                                    {this._measure_editing_form.getFormData()
                                      .eap_pkey_pwd ? (
                                      <span className="icon-lock mr-2" />
                                    ) : null}
                                    {
                                      this._measure_editing_form.getFormData()
                                        .eap_pkey_fname
                                    }
                                  </div>
                                  <div>
                                    <ReactOButton
                                      icon="cancel"
                                      color="light"
                                      size="sm"
                                      disabled={isFieldDisabled}
                                      onClick={() => {
                                        //	remove_action(_C_idx);
                                        this._measure_editing_form.setEntry(
                                          "eap_pkey",
                                          [],
                                        );
                                        this._measure_editing_form.setEntry(
                                          "eap_pkey_pwd",
                                          false,
                                        );
                                        this._measure_editing_form.setEntry(
                                          "eap_pkey_pwd_l",
                                          false,
                                        );
                                        this._measure_editing_form.setEntry(
                                          "eap_pkey_fname",
                                          false,
                                        );
                                      }}
                                    />
                                  </div>
                                </Panel>
                              </div>
                            ) : (
                              <div className="text-muted text-center mb-3">
                                <small>
                                  <strong>No private key uploaded</strong>
                                </small>
                              </div>
                            )}
                          </div>
                        ) : null}
                        <ReactOFormInput
                          className="mb-2"
                          type="upload"
                          data_key="eap_pkey"
                          disabled={isFieldDisabled}
                          size="md"
                          defineIf={(form_data) => {
                            return (
                              form_data.auth == "PEAP" &&
                              form_data.auth_mod == "EAP-TLS"
                            );
                          }}
                          showIf={(form_data) => {
                            return (
                              (form_data.eap_pkey &&
                                form_data.eap_pkey.length &&
                                !form_data.eap_pkey[0].uploaded) ||
                              (form_data.eap_pkey &&
                                form_data.eap_pkey.length == 0) ||
                              !data
                            );
                          }}
                          maxUploads={1}
                          onDropped={(form_ctrl, uploading_queue, cb) => {
                            if (uploading_queue.length) {
                              this.callsSet.call("parse_measure_pkey", {
                                data_input: {
                                  pkey_file: uploading_queue[0],
                                },
                                on_success: (
                                  response_status,
                                  response_data,
                                ) => {
                                  uploading_queue[0] = {
                                    ...uploading_queue[0],
                                    ...response_data[0].data,
                                  };
                                  if (cb) cb(uploading_queue);
                                },
                              });
                            }
                          }}
                          validators={[
                            {
                              func: (value) => {
                                return value.length > 0;
                              },
                              invalid_text: "Load a private key",
                            },
                            {
                              type: "bypass",
                              func: (value, form_data) => {
                                return (
                                  value[0].is_valid === undefined ||
                                  (value[0].parsing_data &&
                                    value[0].parsing_data.encrypted == 1)
                                );
                              },
                            },
                            {
                              func: (value) => {
                                return (
                                  value[0].is_valid === undefined ||
                                  value[0].is_valid == 1
                                );
                              },
                              invalid_text: "Choose a valid RSA Private key",
                            },
                          ]}
                          queueRenderFunction={(data, remove_action) => {
                            return (
                              <div className={data.length ? "p-2" : ""}>
                                <ReactOTable
                                  tdClassName="align-middle px-0"
                                  size="sm"
                                  thDividers
                                  cols={[
                                    {
                                      data_key: "filename",
                                      width: "90",
                                      sortable: true,
                                    },
                                    {
                                      align: "right",
                                      data_key: "action",
                                      width: "10",
                                    },
                                  ]}
                                  rows={(() => {
                                    let _TMP = (data || []).map(
                                      (_C_file, _C_idx) => {
                                        return {
                                          filename: {
                                            value: _C_file.filename,
                                            render: (
                                              <div>
                                                {_C_file.filename}{" "}
                                                {_C_file.is_valid !== undefined
                                                  ? _C_file.is_valid
                                                    ? "(OK)"
                                                    : "(KO)"
                                                  : null}
                                              </div>
                                            ),
                                          },
                                          action: {
                                            render: (
                                              <ReactOButton
                                                icon="cancel"
                                                color="light"
                                                size="sm"
                                                onClick={() => {
                                                  remove_action(_C_idx);
                                                }}
                                              />
                                            ),
                                          },
                                        };
                                      },
                                    );
                                    return _TMP;
                                  })()}
                                />
                                <ReactOFormInput
                                  className="mb-3"
                                  type="password"
                                  data_key="eap_pkey_pwd"
                                  preventCopyCut
                                  watchable
                                  fake={data ? true : false}
                                  label="PKey password"
                                  placeholder="Type password"
                                  autofocus
                                  size="sm"
                                  defineIf={(form_data) => {
                                    return (
                                      form_data.eap_pkey.length &&
                                      form_data.eap_pkey[0].parsing_data &&
                                      form_data.eap_pkey[0].parsing_data
                                        .encrypted
                                    );
                                  }}
                                  validators={[
                                    {
                                      func: (value) => {
                                        return (
                                          value !== undefined &&
                                          /^.+$/.test(value)
                                        );
                                      },
                                      invalid_text: "Type a valid password",
                                    },
                                  ]}
                                  remote_validators={[
                                    {
                                      func: (value) => {
                                        return value == "PKEY_PWD_NOT_VALID"
                                          ? false
                                          : true;
                                      },
                                      invalid_text:
                                        "Wrong password or corrupted private key",
                                    },
                                  ]}
                                />
                              </div>
                            );
                          }}
                        />
                      </Col>
                    </Row>
                    {this._measure_editing_form &&
                    this._measure_editing_form.getFormData().auth == "PEAP" &&
                    this._measure_editing_form.getFormData().auth_mod ==
                      "EAP-TLS" ? (
                      <div>
                        <Row className="mt-3">
                          <Col xs={6}>
                            <ReactOFormInput
                              type="switch"
                              auxiliary
                              label="EAP Identity"
                              data_key="eapanonymousidentity_enabled"
                              disabled={isFieldDisabled}
                              size="md"
                              default="no"
                              switchOnValue="yes"
                              switchOffValue="no"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6}>
                            <ReactOFormInput
                              className="mt-3"
                              type="text"
                              data_key="eapanonymousidentity"
                              disabled={isFieldDisabled}
                              defineIf={(form_data) => {
                                return (
                                  form_data.eapanonymousidentity_enabled ==
                                  "yes"
                                );
                              }}
                              size="md"
                              required
                            />
                          </Col>
                        </Row>
                      </div>
                    ) : null}
                    {this._measure_editing_form &&
                    this._measure_editing_form.getFormData().auth == "PEAP" &&
                    this._measure_editing_form.getFormData().auth_mod ==
                      "EAP-TLS" ? (
                      <Row>
                        <Col>
                          <ReactOFormInput
                            type="error_display"
                            className="text-danger text-center mb-3"
                            render={(message) => {
                              return message &&
                                message.data &&
                                message.data.validation &&
                                message.data.validation.length &&
                                message.data.validation[0].error ===
                                  "CERT_PKEY_NOT_MATCH" ? (
                                <div>
                                  Certificate and Private key not matching
                                </div>
                              ) : null;
                            }}
                          />
                        </Col>
                      </Row>
                    ) : null}
                    {/*
////////////////////////////////////////////
//		INPUT (password) - WPA passphrase
*/}
                    <Row>
                      <Col xs={12} sm={6}>
                        <ReactOFormInput
                          className="mb-3"
                          type="password"
                          data_key="wpapsk"
                          preventCopyCut
                          watchable
                          fake={data ? true : false}
                          disabled={isFieldDisabled}
                          label="WPA passphrase"
                          placeholder="Type password"
                          autofocus
                          size="md"
                          showIf={(form_data) => {
                            return form_data.auth == "PSK";
                          }}
                          defineIf={(form_data) => {
                            // let _TMP_testData = this.state.probe_tests[
                            //   form_data.c_test == "yes" ? "c_tests" : "s_tests"
                            // ].find((value) => {
                            //   return value.name == form_data.test;
                            // });
                            return (
                              form_data.auth == "PSK"
                              // && _TMP_testData?.supportsAuthentication != "no"
                            );
                          }}
                          validators={[
                            {
                              func: (value) => {
                                return (
                                  value !== undefined && /^.+$/.test(value)
                                );
                              },
                              invalid_text: "Type a valid password",
                            },
                          ]}
                        />

                        <ReactOFormInput
                          className="mb-3"
                          type="password"
                          data_key="wpasae"
                          preventCopyCut
                          watchable
                          fake={data ? true : false}
                          disabled={isFieldDisabled}
                          label="WPA passphrase"
                          placeholder="Type password"
                          autofocus
                          size="md"
                          showIf={(form_data) => {
                            return form_data.auth == "SAE";
                          }}
                          defineIf={(form_data) => {
                            return form_data.auth == "SAE";
                          }}
                          validators={[
                            {
                              func: (value) => {
                                return (
                                  value !== undefined && /^.+$/.test(value)
                                );
                              },
                              invalid_text: "Type a valid password",
                            },
                          ]}
                        />

                        {/*
///////////////////////////////////
//		INPUT (text) - PEAP user
*/}

                        <ReactOFormInput
                          className="mb-3"
                          type="text"
                          data_key="peapuser"
                          label="User"
                          placeholder="Type authentication username"
                          disabled={isFieldDisabled}
                          // autofocus
                          size="md"
                          defineIf={(form_data) => {
                            return (
                              form_data.auth == "PEAP" &&
                              form_data.auth_mod == "PEAP"
                            );
                          }}
                          default=""
                          validators={[
                            {
                              func: (value) => {
                                return (
                                  value !== undefined && /^.+$/.test(value)
                                );
                              },
                              invalid_text: "Type a valid username",
                            },
                          ]}
                        />
                      </Col>

                      {/*
////////////////////////////////////////////
//		INPUT (password) - PEAP password
*/}
                      <Col xs={12} sm={6}>
                        <ReactOFormInput
                          className="mb-3"
                          type="password"
                          data_key="peappwd"
                          preventCopyCut
                          watchable
                          fake={data ? true : false}
                          label="Password"
                          placeholder="Type authentication password"
                          disabled={isFieldDisabled}
                          size="md"
                          defineIf={(form_data) => {
                            return (
                              form_data.auth == "PEAP" &&
                              form_data.auth_mod == "PEAP"
                            );
                          }}
                          validators={[
                            {
                              func: (value) => {
                                return (
                                  value !== undefined && /^.+$/.test(value)
                                );
                              },
                              invalid_text: "Type a valid password",
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className="mt-4 mb-3 pb-2 border-bottom border-2 border-primary">
                  <Col xs={12} className="">
                    <strong>MEASURE TESTS</strong>
                  </Col>
                </Row>
                <Row className="px-4">
                  <Col
                    xs={12}
                    sm={
                      this._measure_editing_form?.getFormData().net_type !=
                        "cve" ||
                      (this._measure_editing_form?.getFormData().net_type ==
                        "cve" &&
                        this.state.cveScriptResult)
                        ? 6
                        : 12
                    }
                  >
                    <ReactOFormInput
                      type="hidden"
                      data_key="c_test"
                      default="no"
                    />
                    <ReactOFormInput type="hidden" data_key="sync" default="" />
                    {this._measure_editing_form?.getFormData().net_type ==
                      "cve" && (
                      <div className="d-flex justify-content-between align-items-center">
                        <Label>Test script</Label>
                        <ReactOFormInput
                          type="switch"
                          auxiliary
                          label="Run with Bash Debug"
                          data_key="cve_debug"
                          size="md"
                          default="no"
                          switchOnValue="yes"
                          switchOffValue="no"
                        />
                      </div>
                    )}

                    <ReactOFormInput
                      // label="Test script"
                      type="textarea"
                      data_key="cve_test_script"
                      defineIf={(form_data) => form_data.net_type == "cve"}
                      inputClassName="custom-textarea"
                      // help={<small>Help text</small>}
                    />
                    <ReactOFormInput
                      type="select"
                      data_key="test"
                      label="Test script"
                      defineIf={(form_data) => form_data.net_type != "cve"}
                      scrollable
                      help={
                        <small>
                          <strong>Test script</strong> cannot be modified after
                          measure creation
                        </small>
                      }
                      size="md"
                      disabled={data?.archived || (data ? true : false)}
                      forceFirstDefault
                      onOptionSelect={(form_ctrl, selected_value) => {
                        const selectedTest =
                          this.state.tests_info[selected_value];
                        if (selectedTest.extraParameters) {
                          Object.keys(selectedTest.extraParameters).forEach(
                            (params) => {
                              const { default: defaultValue } =
                                selectedTest.extraParameters[params] || {};
                              if (defaultValue) {
                                form_ctrl.setEntry(
                                  `extraParameters.${params}`,
                                  defaultValue,
                                );
                              } else {
                                form_ctrl.setEntry(
                                  `extraParameters.${params}`,
                                  "",
                                );
                              }
                            },
                          );
                        }

                        form_ctrl.handleFormChange("test", selected_value);
                        form_ctrl.handleFormChange(
                          "c_test",
                          this.state.probe_tests.c_tests.find((value) => {
                            return value.name == selected_value;
                          })
                            ? "yes"
                            : "no",
                        );
                        if (form_ctrl.getEntry("custom_mea_name") == "no") {
                          let _CURR_essid = form_ctrl.getEntry("essid");
                          _CURR_essid =
                            _CURR_essid == "_ALIAS_net_name"
                              ? form_ctrl.getEntry("net_name") || ""
                              : form_ctrl.getEntry("net_type") == "wifi"
                                ? _CURR_essid || ""
                                : "Ethernet";
                          form_ctrl.handleFormChange(
                            "name",
                            _CURR_essid + " with test " + selected_value,
                          );
                        }
                        form_ctrl.handleFormChange(
                          "supportsSync",
                          this.state.probe_tests[
                            form_ctrl.getEntry("c_test") == "yes"
                              ? "c_tests"
                              : "s_tests"
                          ].find((value) => {
                            return (
                              value.name ==
                              this._measure_editing_form.getEntry("test")
                            );
                          })?.supportsSync &&
                            this.state.probe_tests[
                              form_ctrl.getEntry("c_test") == "yes"
                                ? "c_tests"
                                : "s_tests"
                            ].find((value) => {
                              return (
                                value.name ==
                                this._measure_editing_form.getEntry("test")
                              );
                            }).supportsSync != "no"
                            ? "yes"
                            : false,
                        );
                      }}
                      options={(form_data) => {
                        let filteredStests,
                          filteredCtests,
                          sortedStets,
                          sortedCtests = [];

                        if (this.state.probe_tests) {
                          filteredStests = this.filterTests(
                            this.state.probe_tests.s_tests,
                            form_data.net_type,
                          );
                          filteredCtests = this.filterTests(
                            this.state.probe_tests.c_tests,
                            form_data.net_type,
                          );
                          // SORTING
                          sortedStets = this.sortTests(filteredStests);
                          sortedCtests = this.sortTests(filteredCtests);
                        }

                        let _RET = [
                          (item_idx) => {
                            return this.state.tests_info?.countOccurrences
                              .s_tests[form_data.net_type] > 0 ? (
                              <div
                                key={item_idx}
                                className="dropdown-title-divider d-flex align-items-center"
                              >
                                <strong>Standard tests</strong>
                              </div>
                            ) : null;
                          },
                          ...sortedStets
                            .filter((test) => {
                              if (data) return true;
                              const { excludedHW } = test || {};
                              if (excludedHW && hw && excludedHW.includes(hw)) {
                                return false;
                              }
                              return true;
                            })
                            .map((_CURR_test, _CURR_idx) => {
                              return {
                                name: _CURR_test.name,
                                value: _CURR_test.name,
                                desc: _CURR_test.desc,
                              };
                            }),
                          (item_idx) => {
                            return this.state.tests_info?.countOccurrences
                              .c_tests[form_data.net_type] > 0 ? (
                              <div
                                key={item_idx}
                                className="dropdown-title-divider d-flex align-items-center"
                              >
                                <strong>Custom tests</strong>
                              </div>
                            ) : null;
                          },
                          ...sortedCtests.map((_CURR_test, _CURR_idx) => {
                            return {
                              name: _CURR_test.name,
                              value: _CURR_test.name,
                              desc: _CURR_test.desc,
                            };
                          }),
                        ];
                        return _RET;
                      }}
                    />
                  </Col>
                  {this._measure_editing_form?.getFormData().net_type ==
                    "cve" &&
                    this.state.cveScriptResult && (
                      <Col className="" xs="12" sm="6">
                        <Label>
                          Test script result{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            className="icon-new-tab button-card pl-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              const data = {
                                plainText:
                                  this.state.cveScriptResult.decompressedTest,
                              };
                              window.open(
                                "/web/stepviewer?data=" +
                                  encodeURIComponent(JSON.stringify(data)),
                              );
                            }}
                          />
                        </Label>

                        <pre className="bg-dark body-pre text-light m-0 p-2 custom-textarea rounded">
                          {this.state.cveScriptResult.decompressedTest}
                        </pre>
                        <FormText
                          color="muted"
                          className="d-flex align-items-start"
                        >
                          <span
                            className="icon-info mr-1"
                            style={{ fontSize: "130%" }}
                          />
                          <small>
                            Return code:{" "}
                            <strong>
                              {this.state.cveScriptResult.ret_code}
                            </strong>
                            , elapsed:{" "}
                            <strong>
                              {this.state.cveScriptResult.elapsed} ms
                            </strong>
                          </small>
                        </FormText>
                      </Col>
                    )}
                  {this.state.tests_info &&
                  this._measure_editing_form &&
                  this._measure_editing_form?.getFormData().net_type !=
                    "cve" ? (
                    <Col className="pt-3">
                      <label>Description</label>
                      <div className="secondary-desc">
                        {this.state.tests_info &&
                        this.state.tests_info[
                          this._measure_editing_form.getFormData().test
                        ]
                          ? this.state.tests_info[
                              this._measure_editing_form.getFormData().test
                            ].desc
                          : null}
                      </div>
                      {/* HELP */}

                      {this._measure_editing_form.getFormData().test &&
                      this.state.tests_info[
                        this._measure_editing_form.getFormData()?.test
                      ] &&
                      this.state.tests_info[
                        this._measure_editing_form.getFormData()?.test
                      ].doc ? (
                        <div className="secondary-desc">
                          <a
                            href={`/viewer/${
                              this.state.tests_info[
                                this._measure_editing_form.getFormData().test
                              ].doc.filename
                            }`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View more on test script
                          </a>
                        </div>
                      ) : null}
                    </Col>
                  ) : null}
                </Row>
                <Row className="px-4">
                  {this._measure_editing_form?.getFormData().net_type !=
                    "cve" &&
                  this.state.tests_info &&
                  this._measure_editing_form &&
                  this._measure_editing_form.getFormData().test &&
                  this.state.tests_info[
                    this._measure_editing_form.getFormData().test
                  ] &&
                  this.state.tests_info[
                    this._measure_editing_form.getFormData().test
                  ].extraParameters &&
                  this.state.tests_info[
                    this._measure_editing_form.getFormData().test
                  ].extraParameters != null
                    ? Object.keys(
                        this.state.tests_info[
                          this._measure_editing_form.getFormData().test
                        ].extraParameters,
                      )
                        .sort((a, b) => {
                          const params =
                            this.state.tests_info[
                              this._measure_editing_form.getFormData().test
                            ].extraParameters;
                          const aSort = params[a].sort;
                          const bSort = params[b].sort;
                          if (aSort != null && bSort != null) {
                            return aSort - bSort;
                          }
                          return params[a].name.localeCompare(params[b].name);
                        })
                        .map((params, id) => {
                          return (
                            <Col key={params} xs={6} className="mt-3">
                              <ReactOFormInput
                                type="text"
                                disabled={isFieldDisabled}
                                help={
                                  <small>
                                    {
                                      this.state.tests_info[
                                        this._measure_editing_form.getFormData()
                                          .test
                                      ].extraParameters[params].desc
                                    }
                                  </small>
                                }
                                placeholder={
                                  this.state.tests_info[
                                    this._measure_editing_form.getFormData()
                                      .test
                                  ].extraParameters[params].placeholder
                                    ? this.state.tests_info[
                                        this._measure_editing_form.getFormData()
                                          .test
                                      ].extraParameters[params].placeholder
                                    : ""
                                }
                                default={
                                  this.state.tests_info[
                                    this._measure_editing_form.getFormData()
                                      .test
                                  ].extraParameters[params].default
                                    ? this.state.tests_info[
                                        this._measure_editing_form.getFormData()
                                          .test
                                      ].extraParameters[params].default
                                    : ""
                                }
                                data_key={"extraParameters." + params}
                                label={
                                  this.state.tests_info[
                                    this._measure_editing_form.getFormData()
                                      .test
                                  ].extraParameters[params].name
                                }
                                className="mb-1"
                                size="md"
                                validators={[
                                  {
                                    func: (value) => {
                                      const currTest =
                                        this._measure_editing_form.getFormData()
                                          .test;

                                      if (
                                        currTest &&
                                        this.state.tests_info[currTest]
                                          .extraParameters &&
                                        this.state.tests_info[currTest]
                                          .extraParameters[params] &&
                                        this.state.tests_info[currTest]
                                          .extraParameters[params].valid_if
                                      ) {
                                        let parser = new RegExp(
                                          this.state.tests_info[currTest]
                                            .extraParameters[params].valid_if,
                                        );
                                        return parser.test(value);
                                      } else {
                                        return true;
                                      }
                                    },
                                    invalid_text: `Type a valid ${
                                      this.state.tests_info[
                                        this._measure_editing_form.getFormData()
                                          .test
                                      ].extraParameters[params].name
                                    }`,
                                  },
                                ]}
                              />
                            </Col>
                          );
                        })
                    : null}

                  {this.state.tests_info &&
                  this._measure_editing_form &&
                  this._measure_editing_form.getFormData().test &&
                  this.state.tests_info[
                    this._measure_editing_form.getFormData().test
                  ] &&
                  this.state.tests_info[
                    this._measure_editing_form.getFormData().test
                  ].label != null ? (
                    <Col xs={6} className="mt-3">
                      <ReactOFormInput
                        type="select"
                        data_key="label"
                        label="Label measure as:"
                        size="md"
                        forceFirstDefault
                        options={this.state.tests_info[
                          this._measure_editing_form.getFormData().test
                        ].label.map((label) => {
                          return { name: label, value: label };
                        })}
                      />
                    </Col>
                  ) : null}
                </Row>

                <Row
                  className={
                    "mt-4 pb-2" +
                    (this.state._advanced_collapse_opened
                      ? " border-bottom border-2 border-primary"
                      : "")
                  }
                >
                  <Col xs={12}>
                    <ReactOButton
                      icon={
                        this.state._advanced_collapse_opened
                          ? "caret-up-outline"
                          : "caret-down-outline"
                      }
                      iconRight
                      title={
                        this.state._advanced_collapse_opened ? "Hide" : "Show"
                      }
                      text
                      color="body"
                      onClick={() => {
                        this._advanced_collapse.toggle();
                      }}
                    >
                      <strong>ADVANCED</strong>
                    </ReactOButton>
                  </Col>
                </Row>

                <ReactOCollapse
                  onControllerReady={(_collapse_controller) => {
                    this._advanced_collapse = _collapse_controller;
                    this.setState({ _advanced_collapse_opened: false });
                  }}
                  onOpened={() => {
                    this.setState({ _advanced_collapse_opened: true });
                  }}
                  onClosed={() => {
                    this.setState({ _advanced_collapse_opened: false });
                  }}
                >
                  <Row className="mt-3 px-4">
                    <Col xs={12} sm={6}>
                      <ReactOFormInput
                        type="hidden"
                        auxiliary
                        data_key="custom_mea_name"
                        default="no"
                      />
                      <div ref={this._cloneNameRef}>
                        <ReactOFormInput
                          type="text"
                          data_key="name"
                          label="Measure name"
                          placeholder="Type measure name"
                          disabled={isFieldDisabled}
                          size="md"
                          default=""
                          onValueChange={(form_ctrl, new_value) => {
                            form_ctrl.handleFormChange("name", new_value);
                            form_ctrl.handleFormChange(
                              "custom_mea_name",
                              "yes",
                            );
                          }}
                          validators={[
                            {
                              func: (value) => {
                                if (!this.state._cloneMode) return true;
                                return value !== this._cloneOriginalName;
                              },
                              invalid_text:
                                "Please, enter a new name to clone this measure",
                            },
                          ]}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6} className="mt-3 mt-sm-0">
                      {this._measure_editing_form &&
                      this._measure_editing_form.getEntry("supportsSync") ? (
                        <ReactOFormInput
                          type="select"
                          data_key="supportsSync"
                          label="Sync to cloud"
                          size="md"
                          default={data ? "no" : "yes"}
                          disabled={isFieldDisabled}
                          // disabledIf={(form_data) => {
                          //   return this.state.probe_tests[
                          //     form_data.c_test == "yes" ? "c_tests" : "s_tests"
                          //   ].find((value) => {
                          //     return value.name == form_data.test;
                          //   }).supportsSync != "no"
                          //     ? false
                          //     : true;
                          // }}
                          noSelectionLabel="No"
                          options={[
                            { name: "No", value: "no" },
                            {
                              name: "Yes",
                              value: "yes",
                            },
                            // this.getAppContext().getApiStoreService().getCluster()
                          ]}
                        />
                      ) : (
                        <div>
                          <label>Sync to cloud</label>
                          <div className="mt-2 text-muted">Not available</div>
                          <ReactOFormInput
                            type="hidden"
                            data_key="supportsSync"
                            default={false}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                  {this.state.notifications &&
                    this.state.notifications.smart_notifications == "yes" && (
                      <Row className="mt-3 px-4">
                        <Col xs={12} sm={12}>
                          <ReactOFormInput type="hidden" data_key="tags" />
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (e.altKey && e.shiftKey) {
                                this.setState({
                                  disableTags: !this.state.disableTags,
                                });
                              }
                            }}
                          >
                            {!this.state.disableTags ? (
                              <div></div>
                            ) : (this._measure_editing_form &&
                                this._measure_editing_form.getEntry("tags")) ||
                              (!this.state.disableTags &&
                                this.getAppContext().authHandler.getAccountData()
                                  .smart_notifications == "yes") ? (
                              <div>
                                <label>TAGS</label>
                                <CreatableSelect
                                  isClearable={false}
                                  styles={this.customStyles}
                                  isMulti
                                  options={this.createTagsOptions()}
                                  onChange={(newValue) => {
                                    this.setState(
                                      { tagsList: newValue },
                                      () => {
                                        const labels = newValue.map(
                                          (elem) => elem.label,
                                        );
                                        this._measure_editing_form.setEntry(
                                          "tags",
                                          labels,
                                        );
                                      },
                                    );
                                  }}
                                  formatCreateLabel={(inputValue) => (
                                    <span>
                                      <strong>{`<ADD NEW TAG>`}</strong>{" "}
                                      {inputValue}
                                    </span>
                                  )}
                                  value={this.state.tagsList}
                                />
                              </div>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    )}

                  <Row className="px-4">
                    <Col xs={12} sm={6}>
                      <ReactOFormInput
                        className="mt-3"
                        type="select"
                        data_key="bssid"
                        label="Connection criteria"
                        size="md"
                        disabled={isFieldDisabled}
                        defineIf={(form_data) => {
                          return form_data.net_type == "wifi";
                        }}
                        default="All"
                        aliases={[
                          {
                            applyIf: (value) => {
                              return /^\s*([0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}[\s,]+)*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}:*[0-9a-f]{2}\s*$/.test(
                                value,
                              );
                            },
                            to: "bssid_specific_extra",
                          },
                          {
                            applyIf: (value) => {
                              return /^Top[\d]+$/.test(value);
                            },
                            to: "bssid_top_extra",
                          },
                          {
                            applyIf: (value) => {
                              return /^RssiUp-[\d]+$/.test(value);
                            },
                            to: "bssid_rssiup_extra",
                          },
                        ]}
                        options={[
                          { name: "All", value: "All" },
                          { name: "Top", value: "_ALIAS_bssid_top_extra" },
                          {
                            name: "RSSI (better than)",
                            value: "_ALIAS_bssid_rssiup_extra",
                          },
                          {
                            name: "AP MAC (given)",
                            value: "_ALIAS_bssid_specific_extra",
                          },
                        ]}
                      />
                    </Col>

                    <Col xs={12} sm={6}>
                      <ReactOFormInput
                        className="mt-3"
                        type="text"
                        aliasFor={{
                          data_key: "bssid",
                          out_modifier: (value) => {
                            return "Top" + value;
                          },
                          in_modifier: (value) => {
                            let _TMP = /^Top(\d+)$/.exec(value);
                            return _TMP ? _TMP[1] : "";
                          },
                        }}
                        data_key="bssid_top_extra"
                        label="Top n."
                        placeholder="e.g. 3"
                        append={"BSSIDs"}
                        size="md"
                        default=""
                        disabled={isFieldDisabled}
                        //	defineIf={(form_data) => {return /^Top/.test(form_data.bssid)}}
                        // autofocus
                        //	onValueChange={(form_ctrl, new_value) => {
                        //		form_ctrl.handleFormChange('bssid_top_extra', new_value)
                        //		form_ctrl.handleFormChange('bssid', 'Top' + new_value)
                        //	}}
                        validators={[
                          {
                            func: (value) => {
                              return /^\d+$/.test(value);
                            },
                            invalid_text: "Type a valid number",
                          },
                        ]}
                      />

                      <ReactOFormInput
                        className="mt-3"
                        type="text"
                        aliasFor={{
                          data_key: "bssid",
                          out_modifier: (value) => {
                            return "RssiUp-" + value;
                          },
                          in_modifier: (value) => {
                            let _TMP = /^RssiUp-(\d+)$/.exec(value);
                            return _TMP ? _TMP[1] : "";
                          },
                        }}
                        data_key="bssid_rssiup_extra"
                        label="RSSI Threshold"
                        placeholder="e.g. 75"
                        prepend="-"
                        append="dBm"
                        size="md"
                        default=""
                        // autofocus
                        disabled={isFieldDisabled}
                        //	defineIf={(form_data) => {return /^RssiUp\-/.test(form_data.bssid)}}
                        //	onValueChange={(form_ctrl, new_value) => {
                        //		form_ctrl.handleFormChange('bssid_rssiup_extra', new_value)
                        //		form_ctrl.handleFormChange('bssid', 'RssiUp-' + new_value)
                        //	}}
                        validators={[
                          {
                            func: (value) => {
                              return /^\d+$/.test(value);
                            },
                            invalid_text: "Type a valid RSSI value",
                          },
                        ]}
                      />

                      <ReactOFormInput
                        className="mt-3"
                        type="array"
                        aliasFor={{
                          data_key: "bssid",
                          out_modifier: (value) => {
                            return value.join(" ");
                          },
                          in_modifier: (value) => {
                            return value.split(" ");
                          },
                        }}
                        data_key="bssid_specific_extra"
                        label="Specific mac address"
                        //	defineIf={(form_data) => {return Array.isArray(form_data.bssid)}}
                        validators={[
                          {
                            func: (value) => {
                              return value.length > 0;
                            },
                            invalid_text: "Set at least 1 mac address",
                          },
                        ]}
                        onRender={(
                          form_array_data,
                          remove_action,
                          add_action,
                        ) => {
                          return (
                            <div>
                              {form_array_data.map((_CURR_entry, _CURR_idx) => {
                                return (
                                  <ReactOFormInput
                                    key={"bssid_specific_extra." + _CURR_idx}
                                    className="mb-1"
                                    type="text"
                                    disabled={isFieldDisabled}
                                    data_key={
                                      "bssid_specific_extra." + _CURR_idx
                                    }
                                    placeholder="e.g. 12:ab:34:cd:56:ef"
                                    size="md"
                                    append={
                                      <ReactOButton
                                        onClick={() => {
                                          remove_action(_CURR_idx);
                                        }}
                                        icon="minus"
                                        color="gray200"
                                      />
                                    }
                                    // autofocus
                                    //	onValueChange={(form_ctrl, new_value) => {
                                    //		form_ctrl.handleFormChange('bssid_specific_extra.' + _CURR_idx, new_value)
                                    //		form_ctrl.handleFormChange('bssid', form_ctrl.getEntry('bssid_specific_extra').join(','))
                                    //	}}
                                    validators={[
                                      {
                                        func: (value) => {
                                          return /^[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}$/.test(
                                            value,
                                          );
                                        },
                                        invalid_text:
                                          "Type a valid mac address",
                                      },
                                    ]}
                                  />
                                );
                              })}
                              <ReactOActionBar
                                key="2"
                                align="right"
                                padding="0px"
                              >
                                <ReactOButton
                                  onClick={add_action}
                                  icon="plus"
                                  color="gray200"
                                />
                              </ReactOActionBar>
                            </div>
                          );
                        }}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-3 pt-3 px-4 border-top border-2 border-muted">
                    <Col xs={6}>
                      <ReactOFormInput
                        type="switch"
                        auxiliary
                        label="Timeslot"
                        data_key="timeslot_enabled"
                        size="md"
                        default="no"
                        disabled={isFieldDisabled}
                        switchOnValue="yes"
                        switchOffValue="no"
                      />
                    </Col>
                  </Row>
                  <Row className="px-4">
                    <Col xs={6}>
                      <ReactOFormInput
                        className="mt-3"
                        type="text"
                        disabled={isFieldDisabled}
                        help={
                          <small>
                            The measure will run once in every time slot of
                            given seconds on each BSSID specified by the
                            connection criteria.
                          </small>
                        }
                        data_key="timeslot"
                        defineIf={(form_data) => {
                          return form_data.timeslot_enabled == "yes";
                        }}
                        validators={[
                          {
                            type: "bypass",
                            func: (value, form_data) => {
                              return form_data.timeslot_enabled == "no";
                            },
                          },
                          {
                            func: (value) => {
                              return /^\d+$/.test(value);
                            },
                            invalid_text:
                              "Type a valid integer or decimal number",
                          },
                        ]}
                        append="sec."
                        size="md"
                        required
                      />
                    </Col>
                  </Row>

                  {this._measure_editing_form?.getFormData().net_type !=
                    "cve" && (
                    <Row className="mt-3 pt-3 px-4 border-top border-2 border-muted">
                      {this._measure_editing_form?.getEntry("net_type") ==
                        "wifi" && (
                        <Col xs={12} sm={6}>
                          <ReactOFormInput
                            type="select"
                            data_key="altmac"
                            label="Alternative mac address"
                            disabled={isFieldDisabled}
                            help={
                              <small>
                                Select custom set for mac address used as STA
                              </small>
                            }
                            defineIf={(form_data) => {
                              return form_data.net_type == "wifi";
                            }}
                            size="md"
                            default="0"
                            options={[
                              { name: "Native", value: "0" },
                              { name: "1", value: "1" },
                              { name: "2", value: "2" },
                              { name: "3", value: "3" },
                              { name: "4", value: "4" },
                              { name: "5", value: "5" },
                              { name: "6", value: "6" },
                              { name: "7", value: "7" },
                              { name: "8", value: "8" },
                              { name: "9", value: "9" },
                              { name: "10", value: "10" },
                              { name: "11", value: "11" },
                              { name: "12", value: "12" },
                              { name: "13", value: "13" },
                              { name: "14", value: "14" },
                              { name: "15", value: "15" },
                            ]}
                          />
                        </Col>
                      )}

                      <Col xs={12} sm={6} className="mt-3 mt-sm-0">
                        <ReactOFormInput
                          type="select"
                          data_key="pcap"
                          label="Packet capture"
                          defineIf={(form_data) => form_data.net_type != "cve"}
                          disabled={isFieldDisabled}
                          help={
                            <small>
                              Generate packet capture (.pcap file).
                              <br />
                              For same step constant error .pcap generation rate
                              is once every 15 minutes
                            </small>
                          }
                          size="md"
                          default="Never"
                          options={[
                            { name: "Never", value: "Never" },
                            { name: "Only on error", value: "OnError" },
                            { name: "Always", value: "Always" },
                          ]}
                        />
                      </Col>
                    </Row>
                  )}

                  <Row className="mt-3 pt-3 px-4 border-top border-2 border-muted">
                    <Col xs={12} sm={6} className="mt-3 mt-sm-0">
                      <ReactOFormInput
                        type="select"
                        data_key="notifications.threshold"
                        label="ERROR THRESHOLD AT"
                        disabled={isFieldDisabled}
                        // defineIf={(form_data) => {
                        //   return form_data.notifications.enable == "yes";
                        // }}
                        // disabledIf={(form_data) => {
                        //   return (
                        //     this._measure_editing_form.getEntry(
                        //       "notifications.enable"
                        //     ) == "no"
                        //   );
                        // }}
                        size="md-3"
                        modal={() => this._threshold_modal.open()}
                        help={
                          <small>
                            Error condition on the measure when failures are
                            more than threshold.{" "}
                            <span className="text-primary link-color">
                              View more about threshold.
                            </span>
                          </small>
                        }
                        default={"50"}
                        options={[
                          {
                            name: <span className="text">4%</span>,
                            render: () => {
                              return <div className="">4%</div>;
                            },
                            value: "4",
                          },
                          {
                            name: <span className="text">12%</span>,
                            render: () => {
                              return <div className="">12%</div>;
                            },
                            value: "12",
                          },
                          {
                            name: <span className="text">33%</span>,
                            render: () => {
                              return <div className="">33%</div>;
                            },
                            value: "33",
                          },
                          {
                            name: <span className="text">50%</span>,
                            render: () => {
                              return <div className="">50%</div>;
                            },
                            value: "50",
                          },
                          {
                            name: <span className="text">66%</span>,
                            render: () => {
                              return <div className="">66%</div>;
                            },
                            value: "66",
                          },
                        ]}
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <ReactOFormInput
                        type="text"
                        data_key="Yref"
                        label="Y reference time"
                        disabled={isFieldDisabled}
                        help={
                          <small>
                            Measures that take longer than the
                            <strong> Y Reference Time</strong> will be counted
                            as "Slow Measures"
                          </small>
                        }
                        append="sec."
                        size="md"
                        default="10"
                        validators={[
                          {
                            func: (value) => {
                              return /^\d+(\.\d+)*$/.test(value);
                            },
                            invalid_text:
                              "Type a valid integer or decimal number",
                          },
                        ]}
                      />
                    </Col>
                  </Row>

                  {this.getAppContext().isCloud() &&
                  !data?.archived &&
                  (!this.state.notifications?.smart_notifications ||
                    this.state.notifications?.smart_notifications == "no") ? (
                    this.state.notifications &&
                    this.state.notifications.measures ? (
                      <div>
                        <Row className="mt-3 pt-3 px-4 border-top border-2 border-muted">
                          <Col xs={6}>
                            <ReactOFormInput
                              type="switch"
                              label="Mail notifications"
                              data_key="notifications.enable"
                              disabled={isFieldDisabled}
                              size="md"
                              default="no"
                              switchOnValue="yes"
                              switchOffValue="no"
                            />
                          </Col>
                        </Row>
                        <Row className="px-4">
                          <Col>
                            <ReactOFormInput
                              type="hidden"
                              data_key="notifications.mail"
                            />

                            <ReactOFormInput
                              type="div"
                              className="my-2"
                              data_key="div"
                              defineIf={(form_data) => {
                                return form_data.notifications.enable == "yes";
                              }}
                              div_data={
                                <>
                                  {" "}
                                  Send mail to:{" "}
                                  <strong>
                                    {this.state.notifications.measures}
                                  </strong>{" "}
                                  with notify time:{" "}
                                  <strong>
                                    {this.state.notifications.notif_meas_time}{" "}
                                    min
                                  </strong>
                                  . This attribute is set in{" "}
                                  <Link to={"/notifications-settings"}>
                                    <strong>
                                      <span className="icon-envelop mr-1 ml-1" />
                                      Notifications settings
                                    </strong>
                                  </Link>
                                </>
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="px-4">
                          <Col>
                            {data &&
                              data.notifications &&
                              data.notifications.email && (
                                <ReactOFormInput
                                  type="div"
                                  className="my-2"
                                  data_key="div"
                                  defineIf={(form_data) => {
                                    return (
                                      form_data.notifications.enable == "yes"
                                    );
                                  }}
                                  div_data={
                                    <>
                                      <Label>Mail</Label>
                                      <div>{data.notifications.email}</div>
                                    </>
                                  }
                                />
                              )}
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <Row className="mt-3 pt-3 px-4 border-top border-2 border-muted">
                        <Col>
                          <Label> MAIL NOTIFICATIONS </Label>
                          <div>
                            <span className="icon-warning mr-1 text-orange" />{" "}
                            To set error conditions mail notifications, enable
                            general notifications in
                            <Link to={"/notifications-settings"}>
                              <strong>
                                <span className="icon-envelop mr-1 ml-1" />
                                Notifications settings
                              </strong>
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    )
                  ) : null}

                  {this._measure_editing_form?.getFormData().net_type !=
                    "cve" && (
                    <Row className="mt-3 pt-3 px-4 border-top border-2 border-muted">
                      <Col xs={6}>
                        <ReactOFormInput
                          type="switch"
                          auxiliary
                          label="Use proxy"
                          disabled={isFieldDisabled}
                          data_key="httpproxy_enabled"
                          //	defineIf={(form_data) => {return this.state.settings_notifications && this.state.settings_notifications.enable == 'yes'}}
                          size="md"
                          default="no"
                          switchOnValue="yes"
                          switchOffValue="no"
                        />
                      </Col>
                    </Row>
                  )}
                  <Row className="px-4">
                    <Col xs={6}>
                      <ReactOFormInput
                        className="mt-3"
                        type="text"
                        data_key="httpproxy"
                        disabled={isFieldDisabled}
                        defineIf={(form_data) => {
                          return form_data.httpproxy_enabled == "yes";
                        }}
                        label="Proxy url"
                        placeholder="Type proxy url"
                        size="md"
                        required
                      />
                    </Col>
                  </Row>
                  <Row className="px-4">
                    <Col xs={6}>
                      <ReactOFormInput
                        className="mt-3"
                        type="text"
                        data_key="httppauth_user"
                        disabled={isFieldDisabled}
                        defineIf={(form_data) => {
                          return form_data.httpproxy_enabled == "yes";
                        }}
                        label="Proxy auth username"
                        placeholder="Type proxy auth username"
                        size="md"
                        validators={[
                          {
                            type: "bypass",
                            func: (value, form_data) => {
                              return !form_data.httppauth_pwd;
                            },
                          },
                          {
                            func: (value) => {
                              return /^.+$/.test(value);
                            },
                            invalid_text: "Type a valid username",
                          },
                        ]}
                      />
                    </Col>

                    <Col xs={6}>
                      <ReactOFormInput
                        className="mt-3"
                        type="password"
                        data_key="httppauth_pwd"
                        disabled={isFieldDisabled}
                        defineIf={(form_data) => {
                          return form_data.httpproxy_enabled == "yes";
                        }}
                        fake={data ? true : false}
                        watchable
                        label="Proxy auth password"
                        placeholder="Type proxy auth password"
                        size="md"
                        validators={[
                          {
                            type: "bypass",
                            func: (value, form_data) => {
                              return !form_data.httppauth_user;
                            },
                          },
                          {
                            func: (value) => {
                              return /^.+$/.test(value);
                            },
                            invalid_text: "Type a valid password",
                          },
                        ]}
                      />
                    </Col>
                  </Row>
                </ReactOCollapse>
                {/*</Panel>
							</ReactOTabs>*/}
              </ReactOForm>
            );
          }}
          actions={[
            () => {
              if (this._measure_editing_form?.getFormData().net_type == "cve") {
                const test =
                  this._measure_editing_form?.getFormData().cve_test_script;
                const cve_debug =
                  this._measure_editing_form?.getFormData().cve_debug;
                return {
                  text: "Run Script",
                  color: "light",
                  disabled: !test || this.state.loading_action,
                  icon: "play3",
                  action: () => {
                    this.setState({ loading_cve: true }, () => {
                      const gzip = compressGzip(test);
                      const cve_test = encodeBase64(gzip);
                      const label = this.state.ethlabels[1];
                      this.callsSet.call("csv_script", {
                        data_input: { cve_test, label, cve_debug },
                        on_success: (_, response_data) => {
                          const { cve_output, elapsed, ret_code } =
                            response_data[0].data || {};
                          const decoded = base64ToUint8Array(cve_output);
                          const decompressedTest =
                            decompressGzipFromBase64(decoded);
                          this.setState({
                            loading_cve: false,
                            editingModalSize: "xl",
                            cveScriptResult: {
                              decompressedTest,
                              elapsed,
                              ret_code,
                            },
                          });
                        },
                      });
                    });
                  },
                };
              } else {
                return {};
              }
            },
            (data) => {
              if (data && !this.state._cloneMode) {
                return {
                  text: "Clone",
                  color: "light",
                  icon: "copy",
                  className: "mr-auto",
                  disabled: this.state.loading_action,
                  action: () => {
                    this._cloneOriginalName = data?.name || "";
                    this.setState({ _cloneMode: true }, () => {
                      this._measure_editing_form.validate(
                        "name",
                        (is_dirty) => {
                          if (!is_dirty) return;
                          if (
                            this._advanced_collapse &&
                            !this._advanced_collapse.isOpened()
                          ) {
                            this._advanced_collapse.open();
                          }
                          setTimeout(() => {
                            const node = this._cloneNameRef.current;
                            if (node) {
                              node.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                              });
                              const input = node.querySelector("input");
                              if (input) input.focus();
                            }
                          }, 250);
                        },
                      );
                    });
                  },
                };
              } else {
                return {};
              }
            },
            (data) => {
              return {
                text: data?.archived ? "Ok" : "Cancel",
                color: "light",
                action: "close",
                disabled: this.state.loading_action,
              };
            },
            (data) => {
              if (!data?.archived) {
                return {
                  text: data ? "Save" : "Create",
                  color: "primary",
                  icon: "save",
                  disabled: this.state.loading_action,
                  action: () => {
                    this._measure_editing_form.submit((submit_result) => {
                      if (submit_result.status === true) {
                        this._measure_editing_modal.close();
                      } else {
                        const nameInvalid =
                          this._measure_editing_form.getValidationResult(
                            "name",
                          ).result === false;
                        if (nameInvalid) {
                          if (
                            this._advanced_collapse &&
                            !this._advanced_collapse.isOpened()
                          ) {
                            this._advanced_collapse.open();
                          }
                          setTimeout(() => {
                            const node = this._cloneNameRef.current;
                            if (node) {
                              node.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                              });
                              const input = node.querySelector("input");
                              if (input) input.focus();
                            }
                          }, 250);
                        }
                      }
                    });
                  },
                };
              } else {
                return {};
              }
            },
          ]}
        />

        {/*
////////////////////////////////
//		Action confirm Modal
//////////////////////////////
*/}

        <ReactOModal
          modalId="prompt"
          size="md"
          disableEnterKey={true}
          onControllerReady={(modal_context) => {
            this._prompt_modal = modal_context;
          }}
          header={(data) => {
            return data.action_type == "pause"
              ? "Pause measure"
              : data.action_type == "run"
                ? "Run measure"
                : data.action_type == "resume"
                  ? "Clone measure"
                  : data.action_type == "archive"
                    ? "Archive measure"
                    : data.action_type == "test_not_found"
                      ? "Test not found"
                      : "Delete measure";
          }}
          body={(data) => {
            if (data.action_type == "test_not_found") {
              return (
                <span>
                  <strong>{data.test_name}</strong> test not present.
                  <br />
                  Please contact WiFiProbe's customer support.
                </span>
              );
            } else {
              return (
                <div>
                  Are you sure you want to{" "}
                  {data.action_type == "pause"
                    ? "pause"
                    : data.action_type == "run"
                      ? "run"
                      : data.action_type == "resume"
                        ? "clone"
                        : data.action_type == "archive"
                          ? "archive"
                          : "delete"}{" "}
                  <strong>{data.measure_name}?</strong>
                  {data.action_type == "delete" && (
                    <div className="mt-2">
                      <div>
                        <strong>Warning:</strong>
                      </div>
                      Deleting {<strong>{data.measure_name}</strong>} will
                      permanently erase all associated data. <br />
                    </div>
                  )}
                  {data.action_type == "resume" && (
                    <div className="mt-2">
                      A cloned measure <strong>{data.measure_name}</strong> will
                      be generated with identical settings.
                    </div>
                  )}
                </div>
              );
            }
          }}
          actions={[
            {
              text: "Cancel",
              color: "light",
              action: "close",
            },
            (data) => {
              return {
                text:
                  data.action_type == "pause"
                    ? "Pause"
                    : data.action_type == "run"
                      ? "Run"
                      : data.action_type == "resume"
                        ? "Clone"
                        : data.action_type == "archive"
                          ? "Archive"
                          : data.action_type == "test_not_found"
                            ? "Ok"
                            : "Delete",
                color:
                  data.action_type == "pause"
                    ? "warning"
                    : data.action_type == "run"
                      ? "success"
                      : data.action_type == "resume"
                        ? "primary"
                        : data.action_type == "archive"
                          ? "secondary"
                          : data.action_type == "test_not_found"
                            ? "primary"
                            : "danger",
                action: () => {
                  data.action();
                  this._prompt_modal.close();
                },
              };
            },
          ]}
        />

        <ReactOModal
          modalId="threshold"
          size="lg"
          onControllerReady={(modal_context) => {
            this._threshold_modal = modal_context;
          }}
          header="Error Threshold"
          body={() => {
            return (
              <div className="text-secondary">
                <p>
                  The tolerance to anomalies varies depending on the specific
                  use case. The system reports an error condition if a constant
                  anomaly state persists across the measurements for more than
                  ten minutes.
                  <br />
                  However, for sparse anomalies, you can define a custom
                  threshold above which they trigger an error condition. The
                  "ERROR THRESHOLD" is a user-defined value that determines when
                  a sparse anomaly in the last four hours of measurement is
                  considered an error condition.
                </p>
                <p>
                  The picture here illustrates the naming used to classify the
                  different anomaly levels and how you can customize the error
                  state based on their percentage.
                </p>
                <div style={{ width: "90%" }} className="container">
                  <table className="table">
                    <thead className="border-top border-2 border-white">
                      <tr>
                        <th className="text-right threshold" scope="col"></th>
                        <th className="text-right threshold" scope="col">
                          4%
                        </th>
                        <th className="text-right threshold" scope="col">
                          33%
                        </th>
                        <th className="text-right threshold" scope="col">
                          50%
                        </th>
                        <th className="text-right threshold" scope="col">
                          67%
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th className="threshold" scope="row">
                          Working
                        </th>
                        {Array.from({ length: 4 }).map(() => (
                          <td className="bg-success border-right" />
                        ))}
                      </tr>
                      <tr>
                        <th className="threshold" scope="row">
                          Spurious anomalies
                        </th>
                        <td className="bg-danger border-right" />
                        {Array.from({ length: 3 }).map(() => (
                          <td className="bg-success border-right" />
                        ))}
                      </tr>
                      <tr>
                        <th className="threshold" scope="row">
                          Few Anomalies
                        </th>
                        {Array.from({ length: 2 }).map(() => (
                          <td className="bg-danger border-right" />
                        ))}
                        {Array.from({ length: 2 }).map(() => (
                          <td className="bg-success border-right" />
                        ))}
                      </tr>
                      <tr>
                        <th className="threshold" scope="row">
                          Many anomalies
                        </th>
                        {Array.from({ length: 3 }).map(() => (
                          <td className="bg-danger border-right" />
                        ))}
                        <td className="bg-success border-right" />
                      </tr>
                      <tr>
                        <th className="threshold" scope="row">
                          Lot of Errors
                        </th>
                        {Array.from({ length: 4 }).map(() => (
                          <td className="bg-danger border-right" />
                        ))}
                      </tr>
                      <tr>
                        <th className="threshold" scope="row">
                          Continuous errors
                        </th>
                        {Array.from({ length: 4 }).map(() => (
                          <td className="bg-danger border-right" />
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            );
          }}
        />
      </Section>
    );
  }
}

export default contextProvider(
  //	Sites,
  withDefinedContext(ProbeConfig, "ProbeConfig", context_exposed_methods),
  {
    define: null,
  },
);
